
const catalogos = {
    distribuidores_agosto_2025: {
        pagina2: [
            //PAGINA 2
            // ENFRIADORES VERTICALES LÍNEA TRADICIONAL
            {
                id: "enfr-rb-270",
                name: "Enfriador Vertical RB-270",
                brand: "Metalfrio",
                category: "Refrigeración",
                price: 23896,
                description: "Enfriador vertical con puertas de cristal y control electrónico con display de temperatura. Equipado con iluminación LED y refrigerante ecológico R290.",
                whatsappProduct: "Metalfrio RB-270",
                image: "/img/catalogo/ENFR-RB-270.webp",
                manualPdf: "/docs/manuales/ENFR-RB-270.pdf",
                details: [
                    {label: "Capacidad", value: "12 ft³ (340 L)"},
                    {label: "Temperatura", value: "0°C a 7.2°C"},
                    {label: "Motor", value: "1/5 hp"},
                    {label: "Medidas", value: "65 x 60 x 184 cm"},
                    {label: "Voltaje", value: "115 V - 60 Hz"}
                ],
                tags: ["Enfriador", "Vertical", "Cristal", "Metalfrio"]
            },
            {
                id: "enfr-rb-800-2p",
                name: "Enfriador Vertical RB-800-2P",
                brand: "Metalfrio",
                category: "Refrigeración",
                subcategory: "Enfriadores Verticales Línea Tradicional",
                price: 45820,
                description: "Enfriador vertical de alta capacidad con 8 parrillas ajustables, control electrónico e iluminación LED. Refrigerante ecológico R290.",
                whatsappProduct: "Metalfrio RB-800-2P",
                image: "/img/catalogo/ENFR-RB-800-2P.webp",
                manualPdf: "/docs/manuales/ENFR-RB-800-2P.pdf",
                details: [
                    {label: "Capacidad", value: "42 ft³ (1196 L)"},
                    {label: "Temperatura", value: "0°C a 7.2°C"},
                    {label: "Motor", value: "1/2 hp"},
                    {label: "Medidas", value: "137 x 72 x 206 cm"},
                    {label: "Voltaje", value: "115 V - 60 Hz"}
                ],
                tags: ["Enfriador", "Vertical", "Alta Capacidad", "Metalfrio"]
            },
            {
                id: "enfr-rb-800-4p",
                name: "Enfriador Vertical RB-800-4P",
                brand: "Metalfrio",
                category: "Refrigeración",
                subcategory: "Enfriadores Verticales Línea Tradicional",
                price: 47647,
                description: "Enfriador vertical de cuatro puertas con 8 parrillas ajustables, control electrónico e iluminación LED. Refrigerante ecológico R290.",
                whatsappProduct: "Metalfrio RB-800-4P",
                image: "/img/catalogo/ENFR-RB-800-4P.webp",
                manualPdf: "/docs/manuales/ENFR-RB-800-4P-O-ENFR-RB-804.pdf",
                details: [
                    {label: "Capacidad", value: "42 ft³ (1196 L)"},
                    {label: "Temperatura", value: "0°C a 7.2°C"},
                    {label: "Motor", value: "1/2 hp"},
                    {label: "Medidas", value: "137 x 72 x 206 cm"},
                    {label: "Voltaje", value: "115 V - 60 Hz"}
                ],
                tags: ["Enfriador", "Vertical", "4 Puertas", "Metalfrio"]
            },
            // ENFRIADORES 2 PUERTAS LÍNEA "FULL GLASS"
            {
                id: "enfr-rb-100",
                name: "Enfriador Vertical RB-100",
                brand: "Metalfrio",
                category: "Refrigeración",
                subcategory: "Enfriadores 2 Puertas Línea Full Glass",
                price: 21692,
                description: "Enfriador vertical de cristal de alta eficiencia LOW-E con control electrónico y refrigerante ecológico R290.",
                whatsappProduct: "Metalfrio RB-100",
                image: "/img/catalogo/ENFR-RB-100.webp",
                manualPdf: "/docs/manuales/ENFR-RB-100.pdf",
                details: [
                    {label: "Capacidad", value: "10 ft³ (297 L)"},
                    {label: "Temperatura", value: "0°C a 7.2°C"},
                    {label: "Motor", value: "1/5 hp"},
                    {label: "Medidas", value: "54 x 64 x 183 cm"},
                    {label: "Voltaje", value: "115 V - 60 Hz"}
                ],
                tags: ["Enfriador", "Full Glass", "Metalfrio"]
            },
            {
                id: "enfr-rb-410",
                name: "Enfriador Vertical RB-410",
                brand: "Metalfrio",
                category: "Refrigeración",
                subcategory: "Enfriadores 2 Puertas Línea Full Glass",
                price: 26535,
                description: "Enfriador vertical de cristal LOW-E con 5 parrillas ajustables, control electrónico e iluminación LED. Refrigerante ecológico R290.",
                whatsappProduct: "Metalfrio RB-410",
                image: "/img/catalogo/ENFR-RB-410.webp",
                manualPdf: "/docs/manuales/ENFR-RB-410.pdf",
                details: [
                    {label: "Capacidad", value: "19 ft³ (546 L)"},
                    {label: "Temperatura", value: "0°C a 7.2°C"},
                    {label: "Motor", value: "1/5 hp"},
                    {label: "Medidas", value: "64 x 73 x 201 cm"},
                    {label: "Voltaje", value: "115 V - 60 Hz"}
                ],
                tags: ["Enfriador", "Full Glass", "Metalfrio"]
            },
            {
                id: "enfr-rb-470",
                name: "Enfriador Vertical RB-470",
                brand: "Metalfrio",
                category: "Refrigeración",
                subcategory: "Enfriadores 2 Puertas Línea Full Glass",
                price: 29058,
                description: "Enfriador vertical de cristal LOW-E con 5 parrillas ajustables y motor de mayor potencia. Refrigerante ecológico R290.",
                whatsappProduct: "Metalfrio RB-470",
                image: "/img/catalogo/ENFR-RB-470.webp",
                manualPdf: "/docs/manuales/ENFR-RB-470.pdf",
                details: [
                    {label: "Capacidad", value: "21 ft³ (605 L)"},
                    {label: "Temperatura", value: "0°C a 7.2°C"},
                    {label: "Motor", value: "1/4 hp"},
                    {label: "Medidas", value: "72 x 78 x 202 cm"},
                    {label: "Voltaje", value: "115 V - 60 Hz"}
                ],
                tags: ["Enfriador", "Full Glass", "Metalfrio"]
            },
            {
                id: "enfr-rb-550-2p",
                name: "Enfriador Vertical RB-550-2P",
                brand: "Metalfrio",
                category: "Refrigeración",
                subcategory: "Enfriadores 2 Puertas Línea Full Glass",
                price: 35496,
                description: "Enfriador vertical de cristal LOW-E con 6 parrillas ajustables, control electrónico y alta capacidad. Refrigerante ecológico R290.",
                whatsappProduct: "Metalfrio RB-550-2P",
                image: "/img/catalogo/ENFR-RB-550-2P.webp",
                manualPdf: "/docs/manuales/ENFR-RB-550-2P.pdf",
                details: [
                    {label: "Capacidad", value: "26 ft³ (724 L)"},
                    {label: "Temperatura", value: "0°C a 7.2°C"},
                    {label: "Motor", value: "1/2 hp"},
                    {label: "Medidas", value: "100 x 67 x 183 cm"},
                    {label: "Voltaje", value: "115 V - 60 Hz"}
                ],
                tags: ["Enfriador", "Full Glass", "Alta Capacidad"]
            },
            {
                id: "enfr-rb-680-2p",
                name: "Enfriador Vertical RB-680-2P",
                brand: "Metalfrio",
                category: "Refrigeración",
                subcategory: "Enfriadores 2 Puertas Línea Full Glass",
                price: 44689,
                description: "Enfriador vertical de cristal LOW-E con 10 parrillas ajustables y gran volumen de almacenamiento. Refrigerante ecológico R290.",
                whatsappProduct: "Metalfrio RB-680-2P",
                image: "/img/catalogo/ENFR-RB-680-2P.webp",
                manualPdf: "/docs/manuales/ENFR-RB-680-2P.pdf",
                details: [
                    {label: "Capacidad", value: "39 ft³ (1091 L)"},
                    {label: "Temperatura", value: "0°C a 7.2°C"},
                    {label: "Motor", value: "1/2 hp"},
                    {label: "Medidas", value: "109 x 86 x 203 cm"},
                    {label: "Voltaje", value: "115 V - 60 Hz"}
                ],
                tags: ["Enfriador", "Full Glass", "Alta Capacidad"]
            },
            {
                id: "enfri-rb-900-3p",
                name: "Enfriador Vertical RB-900-3P",
                brand: "Metalfrio",
                category: "Refrigeración",
                subcategory: "Enfriadores 2 Puertas Línea Full Glass",
                price: 71978,
                description: "Enfriador vertical de cristal LOW-E con 15 parrillas ajustables, ideal para alto volumen comercial. Refrigerante ecológico R290.",
                whatsappProduct: "Metalfrio RB-900-3P",
                image: "/img/catalogo/ENFRI-RB-900-3P.webp",
                manualPdf: "/docs/manuales/ENFRI-RB-900-3P.pdf",
                details: [
                    {label: "Capacidad", value: "66 ft³ (1883 L)"},
                    {label: "Temperatura", value: "0°C a 7.2°C"},
                    {label: "Motor", value: "1/3 hp"},
                    {label: "Medidas", value: "166 x 83 x 208 cm"},
                    {label: "Voltaje", value: "115 V - 60 Hz"}
                ],
                tags: ["Enfriador", "Full Glass", "Industrial"]
            },
            // ENFRIADOR CERVECERO "SUBZERO" FULL GLASS DOOR
            {
                id: "enfr-vn-25",
                name: "Enfriador Cervecero VN-25",
                brand: "Metalfrio",
                category: "Refrigeración",
                subcategory: "Enfriador Cervecero Subzero Full Glass Door",
                price: 23519,
                description: "Enfriador vertical con tecnología sub-zero y cristal doble de alta eficiencia. Control inteligente e iluminación LED.",
                whatsappProduct: "Metalfrio VN-25",
                image: "/img/catalogo/ENFR-VN-25.webp",
                manualPdf: "/docs/manuales/ENFR-VN-25.pdf",
                details: [
                    {label: "Capacidad", value: "10 ft³ (297 L)"},
                    {label: "Temperatura", value: "-1.5°C a -5.5°C"},
                    {label: "Motor", value: "1/5 hp"},
                    {label: "Medidas", value: "54 x 64 x 183 cm"},
                    {label: "Voltaje", value: "115 V - 60 Hz"}
                ],
                tags: ["Cervecero", "Subzero", "Metalfrio"]
            },
            {
                id: "enfr-vn-55",
                name: "Enfriador Cervecero VN-55",
                brand: "Metalfrio",
                category: "Refrigeración",
                subcategory: "Enfriador Cervecero Subzero Full Glass Door",
                price: 29116,
                description: "Enfriador cervecero vertical con tecnología sub-zero y cristal doble de alta eficiencia. Control inteligente con temperatura visible e iluminación LED de alta intensidad.",
                whatsappProduct: "Metalfrio VN-55",
                image: "/img/catalogo/ENFR-VN-55.webp",
                manualPdf: "/docs/manuales/ENFR-VN-55.pdf",
                details: [
                    {label: "Capacidad", value: "21 ft³ (605 L)"},
                    {label: "Temperatura", value: "-1.5°C a -5.5°C"},
                    {label: "Motor", value: "1/4 hp"},
                    {label: "Medidas", value: "72 x 78 x 202 cm"},
                    {label: "Voltaje", value: "115 V - 60 Hz"}
                ],
                tags: ["Cervecero", "Subzero", "Metalfrio"]
            },
            {
                id: "enfr-vn-100",
                name: "Enfriador Cervecero VN-100",
                brand: "Metalfrio",
                category: "Refrigeración",
                subcategory: "Enfriador Cervecero Subzero Full Glass Door",
                price: 49358,
                description: "Enfriador cervecero vertical sub-zero de alta capacidad con cristal doble, control inteligente e iluminación LED de alta intensidad.",
                whatsappProduct: "Metalfrio VN-100",
                image: "/img/catalogo/ENFR-VN-100.webp",
                manualPdf: "/docs/manuales/ENFR-VN-100.pdf",
                details: [
                    {label: "Capacidad", value: "39 ft³ (1091 L)"},
                    {label: "Temperatura", value: "-1.5°C a -5.5°C"},
                    {label: "Motor", value: "1/3 hp"},
                    {label: "Medidas", value: "109 x 86 x 204 cm"},
                    {label: "Voltaje", value: "115 V - 60 Hz"}
                ],
                tags: ["Cervecero", "Subzero", "Alta Capacidad"]
            },
            {
                id: "enfr-vn-135",
                name: "Enfriador Cervecero VN-135",
                brand: "Metalfrio",
                category: "Refrigeración",
                subcategory: "Enfriador Cervecero Subzero Full Glass Door",
                price: 73544,
                description: "Enfriador cervecero sub-zero de gran volumen con cristal doble, control inteligente e iluminación LED de alta intensidad.",
                whatsappProduct: "Metalfrio VN-135",
                image: "/img/catalogo/ENFR-VN-135.webp",
                manualPdf: "/docs/manuales/ENFR-VN-135.pdf",
                details: [
                    {label: "Capacidad", value: "66 ft³ (1883 L)"},
                    {label: "Temperatura", value: "-1.5°C a -5.5°C"},
                    {label: "Motor", value: "(2) x 1/3 hp"},
                    {label: "Medidas", value: "166 x 83 x 208 cm"},
                    {label: "Voltaje", value: "115 V - 60 Hz"}
                ],
                tags: ["Cervecero", "Subzero", "Industrial"]
            },
            // ENFRIADOR BAJO BARRA "SUB-ZERO"
            {
                id: "enfr-vnh-330",
                name: "Enfriador Bajo Barra VNH-330",
                brand: "Metalfrio",
                category: "Refrigeración",
                subcategory: "Enfriador Bajo Barra Sub-Zero",
                price: 25491,
                description: "Enfriador horizontal bajo barra con puerta sólida deslizable y control electrónico. Refrigerante ecológico R290.",
                whatsappProduct: "Metalfrio VNH-330",
                image: "/img/catalogo/ENFR-VNH-33.webp",
                manualPdf: "/docs/manuales/ENFR-VNH-330.pdf",
                details: [
                    {label: "Capacidad", value: "12 ft³ (330 L)"},
                    {label: "Temperatura", value: "-1.5°C a -5.5°C"},
                    {label: "Motor", value: "1/4 hp"},
                    {label: "Medidas", value: "117 x 62 x 95 cm"},
                    {label: "Voltaje", value: "115 V - 60 Hz"}
                ],
                tags: ["Bajo Barra", "Subzero", "Metalfrio"]
            },
        ],
        pagina3: [
            //PAGINA 3
            //CONSERVADORES DE CONGELADOS VERTICALES AIRE FORZADO (CERTIFICADO FIDE)
            {
                id: "cons-vf-50",
                name: "Conservador Vertical de Congelados VF-50",
                brand: "Metalfrio",
                category: "Refrigeración",
                subcategory: "Conservadores de Congelados Verticales Aire Forzado (Certificado FIDE)",
                price: 43442,
                description: "Congelador vertical con puerta de vidrio de alta eficiencia LOW-E, sistema de aire forzado e iluminación interior LED. Utiliza refrigerante ecológico R290.",
                whatsappProduct: "Metalfrio VF-50",
                image: "/img/catalogo/CONS-VF-50.webp",
                manualPdf: "/docs/manuales/CONS-VF-50.pdf",
                details: [
                    {label: "Capacidad", value: "20 ft³ (555 L)"},
                    {label: "Temperatura", value: "-18°C a -23°C"},
                    {label: "Motor", value: "1/5 hp"},
                    {label: "Medidas", value: "68 x 85 x 202 cm"},
                    {label: "Voltaje", value: "115 V - 60 Hz"}
                ],
                tags: ["Congelador", "Vertical", "Aire Forzado", "FIDE"]
            },
            {
                id: "cons-cvc-08",
                name: "Conservador Vertical de Congelados CVC-08",
                brand: "Metalfrio",
                category: "Refrigeración",
                subcategory: "Conservadores de Congelados Verticales Aire Forzado (Certificado FIDE)",
                price: 28594,
                description: "Congelador vertical compacto con puerta de vidrio LOW-E, sistema de aire forzado e iluminación LED interior. Refrigerante ecológico R290.",
                whatsappProduct: "Metalfrio CVC-08",
                image: "/img/catalogo/CONS-CVC-08.webp",
                manualPdf: "/docs/manuales/CONS-CVC-08.pdf",
                details: [
                    {label: "Capacidad", value: "8 ft³ (222 L)"},
                    {label: "Temperatura", value: "-18°C a -23°C"},
                    {label: "Motor", value: "1/4 hp"},
                    {label: "Medidas", value: "50 x 61 x 184 cm"},
                    {label: "Voltaje", value: "115 V - 60 Hz"}
                ],
                tags: ["Congelador", "Vertical", "Compacto", "FIDE"]
            },
            // CONSERVADORES DE CONGELADOS VERTICALES ESTÁTICOS
            {
                id: "cons-cvc-15",
                name: "Conservador Vertical de Congelados CVC-15",
                brand: "Metalfrio",
                category: "Refrigeración",
                subcategory: "Conservadores de Congelados Verticales Estáticos",
                price: 26361,
                description: "Congelador vertical con puerta de vidrio y cristal triple de alta eficiencia. Equipado con termostato mecánico, condensador WOT de bajo mantenimiento e iluminación LED. Refrigerante ecológico R290.",
                whatsappProduct: "Metalfrio CVC-15",
                image: "/img/catalogo/CONS-CVC-15.webp",
                manualPdf: "/docs/manuales/CONS-CVC-15.pdf",
                details: [
                    {label: "Capacidad", value: "15 ft³ (430 L)"},
                    {label: "Temperatura", value: "-18°C a -23°C"},
                    {label: "Motor", value: "1/4+ hp"},
                    {label: "Medidas", value: "71 x 79 x 167 cm"},
                    {label: "Voltaje", value: "115 V - 60 Hz"}
                ],
                tags: ["Congelador", "Vertical", "Estático", "Metalfrio"]
            },
            // CONSERVADOR CONGELADOS TAPA DE COFRE
            {
                id: "cons-cpc-15",
                name: "Conservador de Congelados Tapa de Cofre CPC-15",
                brand: "Metalfrio",
                category: "Refrigeración",
                subcategory: "Conservador Congelados Tapa de Cofre",
                price: 17922,
                description: "Congelador horizontal tipo cofre con cerradura de seguridad y refrigerante ecológico R290.",
                whatsappProduct: "Metalfrio CPC-15",
                image: "/img/catalogo/CONS-CPC-15.webp",
                manualPdf: "/docs/manuales/CONS-CPC-15.pdf",
                details: [
                    {label: "Capacidad", value: "15 ft³"},
                    {label: "Temperatura", value: "-18°C a -24°C"},
                    {label: "Motor", value: "1/5 hp"},
                    {label: "Medidas", value: "130 x 65 x 91 cm"},
                    {label: "Voltaje", value: "115 V / 60 Hz / 2.5 A"}
                ],
                tags: ["Congelador", "Cofre", "Horizontal"]
            },
            {
                id: "cons-cpc-25",
                name: "Conservador de Congelados Tapa de Cofre CPC-25",
                brand: "Metalfrio",
                category: "Refrigeración",
                subcategory: "Conservador Congelados Tapa de Cofre",
                price: 22098,
                description: "Congelador horizontal tipo cofre de mayor capacidad, con cerradura de seguridad y refrigerante ecológico R290.",
                whatsappProduct: "Metalfrio CPC-25",
                image: "/img/catalogo/CONS-CPC-25.webp",
                manualPdf: "/docs/manuales/CONS-CPC-25.pdf",
                details: [
                    {label: "Capacidad", value: "25 ft³"},
                    {label: "Temperatura", value: "-18°C a -24°C"},
                    {label: "Motor", value: "1/5 hp"},
                    {label: "Medidas", value: "187 x 65 x 91 cm"},
                    {label: "Voltaje", value: "115 V / 60 Hz / 3.5 A"}
                ],
                tags: ["Congelador", "Cofre", "Alta Capacidad"]
            },
            // VITRINAS DE PISO PASTELERAS
            {
                id: "vitr-vcm-100",
                name: "Vitrina de Piso Pastelera VCM-100",
                brand: "Metalfrio",
                category: "Refrigeración",
                subcategory: "Vitrinas de Piso Pasteleras",
                price: 36801,
                description: "Vitrina pastelera de piso con cristal curvo, cubierta y piso en acero inoxidable e iluminación LED. Refrigerante ecológico R290.",
                whatsappProduct: "Metalfrio VCM-100",
                image: "/img/catalogo/VITR-VCM-100.webp",
                manualPdf: "/docs/manuales/VITR-VCM-100.pdf",
                details: [
                    {label: "Capacidad", value: "14.66 ft³"},
                    {label: "Temperatura", value: "1°C a 6°C"},
                    {label: "Parrillas", value: "2 ajustables"},
                    {label: "Motor", value: "1/3 hp"},
                    {label: "Medidas", value: "99 x 85 x 121 cm"}
                ],
                tags: ["Vitrina", "Pastelera", "Piso"]
            },
            {
                id: "vitr-vcm-150",
                name: "Vitrina de Piso Pastelera VCM-150",
                brand: "Metalfrio",
                category: "Refrigeración",
                subcategory: "Vitrinas de Piso Pasteleras",
                price: 44196,
                description: "Vitrina pastelera de piso con mayor capacidad, cristal curvo e iluminación LED. Refrigerante ecológico R290.",
                whatsappProduct: "Metalfrio VCM-150",
                image: "/img/catalogo/VITR-VCM-150.webp",
                manualPdf: "/docs/manuales/VITR-VCM-150.pdf",
                details: [
                    {label: "Capacidad", value: "22.76 ft³"},
                    {label: "Temperatura", value: "1°C a 6°C"},
                    {label: "Parrillas", value: "4 ajustables"},
                    {label: "Motor", value: "1/3 hp"},
                    {label: "Medidas", value: "149 x 83 x 121 cm"}
                ],
                tags: ["Vitrina", "Pastelera", "Alta Capacidad"]
            },
            {
                id: "vitr-vcm-200",
                name: "Vitrina de Piso Pastelera VCM-200",
                brand: "Metalfrio",
                category: "Refrigeración",
                subcategory: "Vitrinas de Piso Pasteleras",
                price: 51765,
                description: "Vitrina pastelera de piso de gran formato, cristal curvo, iluminación LED y refrigerante ecológico R290.",
                whatsappProduct: "Metalfrio VCM-200",
                image: "/img/catalogo/VITR-VCM-200.webp",
                manualPdf: "/docs/manuales/VITR-VCM-200.pdf",
                details: [
                    {label: "Capacidad", value: "30.88 ft³"},
                    {label: "Temperatura", value: "1°C a 6°C"},
                    {label: "Parrillas", value: "4 ajustables"},
                    {label: "Motor", value: "1/3 hp"},
                    {label: "Medidas", value: "200 x 85 x 121 cm"}
                ],
                tags: ["Vitrina", "Pastelera", "Industrial"]
            },

            // CONSERVADOR CONGELADOS HORIZONTAL CURVOS / VERTICAL PUERTA DE CRISTAL
            {
                id: "cons-chc-200",
                name: "Conservador de Congelados CHC-200",
                brand: "Metalfrio",
                category: "Refrigeración",
                subcategory: "Conservador Congelados Horizontal Curvos / Vertical Puerta de Cristal",
                price: 17313,
                description: "Congelador horizontal con 2 puertas corredizas de cristal, condensador auxiliar, ruedas multigiro, canastilla incluida y refrigerante ecológico R290.",
                whatsappProduct: "Metalfrio CHC-200",
                image: "/img/catalogo/CONS-CHC-200.webp",
                manualPdf: "/docs/manuales/CONS-CHC-200.pdf",
                details: [
                    {label: "Capacidad", value: "7 ft³ (201 L)"},
                    {label: "Temperatura", value: "-18°C a -23°C"},
                    {label: "Motor", value: "1/4 hp"},
                    {label: "Medidas", value: "75 x 65 x 91 cm"},
                    {label: "Voltaje", value: "115 V - 60 Hz"}
                ],
                tags: ["Congelador", "Horizontal", "Cristal"],
            },
            {
                id: "cons-chc-300",
                name: "Conservador de Congelados CHC-300",
                brand: "Metalfrio",
                category: "Refrigeración",
                subcategory: "Conservador Congelados Horizontal Curvos / Vertical Puerta de Cristal",
                price: 19372,
                description: "Congelador horizontal de mayor capacidad con puertas corredizas de cristal, condensador auxiliar y refrigerante ecológico R290.",
                whatsappProduct: "Metalfrio CHC-300",
                image: "/img/catalogo/CONS-CHC-300.webp",
                manualPdf: "/docs/manuales/CONS-CHC-300.pdf",
                details: [
                    {label: "Capacidad", value: "11 ft³ (309 L)"},
                    {label: "Temperatura", value: "-18°C a -23°C"},
                    {label: "Motor", value: "1/4 hp"},
                    {label: "Medidas", value: "104 x 65 x 91 cm"},
                    {label: "Voltaje", value: "115 V - 60 Hz"}
                ],
                tags: ["Congelador", "Horizontal", "Alta Capacidad"],
            },
            {
                id: "cons-chc-400",
                name: "Conservador de Congelados CHC-400",
                brand: "Metalfrio",
                category: "Refrigeración",
                subcategory: "Conservador Congelados Horizontal Curvos / Vertical Puerta de Cristal",
                price: 21402,
                description: "Congelador horizontal con amplio espacio interior, puertas de cristal corredizas y refrigerante ecológico R290.",
                whatsappProduct: "Metalfrio CHC-400",
                image: "/img/catalogo/CONS-CHC-400.webp",
                manualPdf: "/docs/manuales/CONS-CHC-400.pdf",
                details: [
                    {label: "Capacidad", value: "14 ft³ (408 L)"},
                    {label: "Temperatura", value: "-18°C a -23°C"},
                    {label: "Motor", value: "1/4 hp"},
                    {label: "Medidas", value: "131 x 65 x 91 cm"},
                    {label: "Voltaje", value: "115 V - 60 Hz"}
                ],
                tags: ["Congelador", "Horizontal"],
            },
            {
                id: "cons-chc-600",
                name: "Conservador de Congelados CHC-600",
                brand: "Metalfrio",
                category: "Refrigeración",
                subcategory: "Conservador Congelados Horizontal Curvos / Vertical Puerta de Cristal",
                price: 27318,
                description: "Congelador horizontal de gran capacidad con puertas corredizas de cristal, condensador auxiliar y refrigerante ecológico R290.",
                whatsappProduct: "Metalfrio CHC-600",
                image: "/img/catalogo/CONS-CHC-600.webp",
                manualPdf: "/docs/manuales/CONS-CHC-600.pdf",
                details: [
                    {label: "Capacidad", value: "21 ft³ (581 L)"},
                    {label: "Temperatura", value: "-18°C a -23°C"},
                    {label: "Motor", value: "1/4 hp"},
                    {label: "Medidas", value: "177 x 65 x 91 cm"},
                    {label: "Voltaje", value: "115 V - 60 Hz"}
                ],
                tags: ["Congelador", "Horizontal", "Industrial"],
            },
            {
                id: "cons-chv-15",
                name: "Conservador Vertical Puerta de Cristal CHV-15",
                brand: "Metalfrio",
                category: "Refrigeración",
                subcategory: "Vertical Puerta de Cristal Recto",
                price: 26361,
                description: "Conservador vertical con 3 puertas corredizas, termostato mecánico, iluminación interior LED y refrigerante ecológico R290.",
                whatsappProduct: "Metalfrio CHV-15",
                image: "/img/catalogo/CONS-CHV-15.webp",
                manualPdf: "/docs/manuales/CONS-CHV-15.pdf",
                details: [
                    {label: "Capacidad", value: "16 ft³ (461 L)"},
                    {label: "Temperatura", value: "-18°C a -23°C"},
                    {label: "Motor", value: "1/3 hp"},
                    {label: "Medidas", value: "188 x 65 x 92 cm"},
                    {label: "Voltaje", value: "115 V - 60 Hz"}
                ],
                tags: ["Congelador", "Vertical", "Cristal"],
            },
        ],
        pagina4: [
            //PAGINA 4
            // CONSERVADOR DE CONGELADOS TAPA DE COFRE
            {
                id: "cons-gc-tc-05",
                name: "Conservador de Congelados Tapa de Cofre GC-TC-05",
                brand: "Gelum",
                category: "Refrigeración",
                subcategory: "Conservador de Congelados Tapa de Cofre",
                price: 6612,
                description: "Conservador de congelados tipo cofre para operación entre -12°C a -24°C o 0°C a 10°C, con termostato mecánico y refrigerante ecológico R290.",
                whatsappProduct: "Gelum GC-TC-05",
                image: "/img/catalogo/CONS-GC-TC-05.webp",
                manualPdf: "/docs/manuales/CONS-GC-TC-05.pdf",
                details: [
                    {label: "Capacidad", value: "5 ft³"},
                    {label: "Temperatura", value: "-12°C a -24°C / 0°C a 10°C"},
                    {label: "Motor", value: "1/6 hp"},
                    {label: "Voltaje", value: "115 V / 60 Hz / 1.4 A"},
                    {label: "Medidas", value: "75 x 56 x 85 cm"}
                ],
                tags: ["Congelador", "Cofre", "Gelum"],
            },
            {
                id: "cons-gc-tc-07",
                name: "Conservador de Congelados Tapa de Cofre GC-TC-07",
                brand: "Gelum",
                category: "Refrigeración",
                subcategory: "Conservador de Congelados Tapa de Cofre",
                price: 7859,
                description: "Conservador tipo cofre de mayor capacidad, con control por termostato mecánico y refrigerante ecológico R290.",
                whatsappProduct: "Gelum GC-TC-07",
                image: "/img/catalogo/CONS-GC-TC-07.webp",
                manualPdf: "/docs/manuales/CONS-GC-TC-07.pdf",
                details: [
                    {label: "Capacidad", value: "7 ft³"},
                    {label: "Temperatura", value: "-12°C a -24°C / 0°C a 10°C"},
                    {label: "Motor", value: "1/6 hp"},
                    {label: "Voltaje", value: "115 V / 60 Hz / 1.4 A"},
                    {label: "Medidas", value: "95 x 56 x 85 cm"}
                ],
                tags: ["Congelador", "Cofre"],
            },
            {
                id: "cons-gc-tc-10",
                name: "Conservador de Congelados Tapa de Cofre GC-TC-10",
                brand: "Gelum",
                category: "Refrigeración",
                subcategory: "Conservador de Congelados Tapa de Cofre",
                price: 10034,
                description: "Conservador tipo cofre con mayor potencia de motor y operación continua. Refrigerante ecológico R290.",
                whatsappProduct: "Gelum GC-TC-10",
                image: "/img/catalogo/CONS-GC-TC-10.webp",
                manualPdf: "/docs/manuales/CONS-GC-TC-10.pdf",
                details: [
                    {label: "Capacidad", value: "10 ft³"},
                    {label: "Temperatura", value: "-12°C a -24°C / 0°C a 10°C"},
                    {label: "Motor", value: "1/4 hp"},
                    {label: "Voltaje", value: "115 V / 60 Hz / 2.2 A"},
                    {label: "Medidas", value: "112 x 64 x 85 cm"}
                ],
                tags: ["Congelador", "Cofre"],
            },
            {
                id: "cons-gc-tc-15",
                name: "Conservador de Congelados Tapa de Cofre GC-TC-15",
                brand: "Gelum",
                category: "Refrigeración",
                subcategory: "Conservador de Congelados Tapa de Cofre",
                price: 16501,
                description: "Conservador tipo cofre de alta capacidad, con motor de mayor potencia y refrigerante ecológico R290.",
                whatsappProduct: "Gelum GC-TC-15",
                image: "/img/catalogo/CONS-GC-TC-15.webp",
                manualPdf: "/docs/manuales/CONS-GC-TC-15.pdf",
                details: [
                    {label: "Capacidad", value: "15 ft³"},
                    {label: "Temperatura", value: "-12°C a -24°C / 0°C a 10°C"},
                    {label: "Motor", value: "1/3+ hp"},
                    {label: "Voltaje", value: "115 V / 60 Hz / 2.8 A"},
                    {label: "Medidas", value: "154 x 74 x 82 cm"}
                ],
                tags: ["Congelador", "Cofre", "Alta Capacidad"],
            },
            {
                id: "cons-gc-tc-25",
                name: "Conservador de Congelados Tapa de Cofre GC-TC-25",
                brand: "Gelum",
                category: "Refrigeración",
                subcategory: "Conservador de Congelados Tapa de Cofre",
                price: 21025,
                description: "Conservador tipo cofre de gran volumen con refrigerante ecológico R290 y opción de ruedas.",
                whatsappProduct: "Gelum GC-TC-25",
                image: "/img/catalogo/CONS-GC-TC-25.webp",
                manualPdf: "/docs/manuales/CONS-GC-TC-25.pdf",
                details: [
                    {label: "Capacidad", value: "20 ft³"},
                    {label: "Temperatura", value: "-12°C a -24°C / 0°C a 10°C"},
                    {label: "Motor", value: "1/2+ hp"},
                    {label: "Voltaje", value: "115 V / 60 Hz / 3.6 A"},
                    {label: "Medidas", value: "193 x 71 x 83 cm"}
                ],
                tags: ["Congelador", "Cofre", "Industrial"],
            },
            {
                id: "cons-gc-tc-28",
                name: "Conservador de Congelados Tapa de Cofre GC-TC-28",
                brand: "Gelum",
                category: "Refrigeración",
                subcategory: "Conservador de Congelados Tapa de Cofre",
                price: 22098,
                description: "Conservador tipo cofre de gran capacidad con operación continua y refrigerante ecológico R290.",
                whatsappProduct: "Gelum GC-TC-28",
                image: "/img/catalogo/CONS-GC-TC-28.webp",
                manualPdf: "", // No se encontró PDF ni Imagen en manuales
                details: [
                    {label: "Capacidad", value: "25 ft³"},
                    {label: "Temperatura", value: "-12°C a -24°C / 0°C a 10°C"},
                    {label: "Motor", value: "1/2+ hp"},
                    {label: "Voltaje", value: "115 V / 60 Hz / 3.6 A"},
                    {label: "Medidas", value: "195 x 80 x 83 cm"}
                ],
                tags: ["Congelador", "Cofre"],
            },
            {
                id: "cons-gc-tc-28-ai",
                name: "Conservador de Congelados Tapa de Cofre GC-TC-28-AI",
                brand: "Gelum",
                category: "Refrigeración",
                subcategory: "Conservador de Congelados Tapa de Cofre",
                price: 23200,
                description: "Conservador tipo cofre con aislamiento mejorado, operación continua y refrigerante ecológico R290.",
                whatsappProduct: "Gelum GC-TC-28-AI",
                image: "/img/catalogo/CONS-GC-TC-28-AI.webp",
                manualPdf: "", // No se encontró manual
                details: [
                    {label: "Capacidad", value: "25 ft³ (708 L)"},
                    {label: "Temperatura", value: "-12°C a -24°C / 0°C a 10°C"},
                    {label: "Motor", value: "1/2+ hp"},
                    {label: "Voltaje", value: "115 V / 60 Hz / 3.6 A"},
                    {label: "Medidas", value: "195 x 80 x 83 cm"}
                ],
                tags: ["Congelador", "Cofre", "AI"],
            },
            {
                id: "cons-gc-ch-15-3",
                name: "Conservador de Congelados Puertas de Vidrio CH-15-3",
                brand: "Gelum",
                category: "Refrigeración",
                subcategory: "Conservador de Congelados Puertas de Vidrio Corredizas",
                price: 22040,
                description: "Conservador de congelados con puertas de vidrio deslizables y desmontables, sistema de evaporador y condensador estático y aislamiento ecológico.",
                whatsappProduct: "Gelum CH-15-3",
                image: "/img/catalogo/CONS-GC-CH-15-3.webp",
                manualPdf: "",
                details: [
                    {label: "Capacidad", value: "15 ft³"},
                    {label: "Temperatura", value: "-18°C a -24°C"},
                    {label: "Motor", value: "1/2 hp"},
                    {label: "Voltaje", value: "115 V / 60 Hz / 3.6 A"},
                    {label: "Medidas", value: "169 x 68 x 78 cm"}
                ],
                tags: ["Congelador", "Cristal", "Horizontal"],
            },
            // REFRIGERACIÓN COMERCIAL - VITRINAS --> VITRINAS PISO VIDRIO CURVO DELI
            {
                id: "gd-vfg-pc-90-3",
                name: "Vitrina Piso Vidrio Curvo Deli GD-VFG-PC-90-3",
                brand: "Gelum",
                category: "Refrigeración",
                subcategory: "Vitrinas Piso Vidrio Curvo Deli",
                price: 45414,
                description: "Vitrina refrigerada de piso con diseño de cristal curvo, panel frontal anti neblina y control electrónico de temperatura. Iluminación LED interior.",
                whatsappProduct: "Gelum GD-VFG-PC-90-3",
                image: "/img/catalogo/GD-VFG-PC-90-3.webp",
                manualPdf: "",
                details: [
                    {label: "Capacidad", value: "7.41 ft³"},
                    {label: "Temperatura", value: "0°C a 6°C"},
                    {label: "Voltaje", value: "220 V / 60 Hz"},
                    {label: "Medidas", value: "90 x 70 x 120 cm"}
                ],
                tags: ["Vitrina", "Deli", "Curvo"],
            },
            {
                id: "gd-vfg-pc-150-3",
                name: "Vitrina Piso Vidrio Curvo Deli GD-VFG-PC-150-3",
                brand: "Gelum",
                category: "Refrigeración",
                subcategory: "Vitrinas Piso Vidrio Curvo Deli",
                price: 57043,
                description: "Vitrina refrigerada de piso con mayor capacidad, cristal curvo y control electrónico de temperatura. Iluminación LED interior.",
                whatsappProduct: "Gelum GD-VFG-PC-150-3",
                image: "/img/catalogo/GD-VFG-PC-150-3.webp",
                manualPdf: "",
                details: [
                    {label: "Capacidad", value: "12.71 ft³"},
                    {label: "Temperatura", value: "0°C a 6°C"},
                    {label: "Voltaje", value: "220 V / 60 Hz"},
                    {label: "Medidas", value: "150 x 70 x 120 cm"}
                ],
                tags: ["Vitrina", "Deli", "Curvo", "Alta Capacidad"],
            },
            {
                id: "gd-vfg-pc-210-3",
                name: "Vitrina Piso Vidrio Curvo Deli GD-VFG-PC-210-3",
                brand: "Gelum",
                category: "Refrigeración",
                subcategory: "Vitrinas Piso Vidrio Curvo Deli",
                price: 64728,
                description: "Vitrina refrigerada de piso de gran formato con cristal curvo, control electrónico e iluminación LED interior.",
                whatsappProduct: "Gelum GD-VFG-PC-210-3",
                image: "/img/catalogo/GD-VFG-PC-210-3.webp", // No estaba en catalogo, pero sí en manuales como webp
                manualPdf: "/docs/manuales/GD-VFG-PC-210-3.webp", // Imagen usada como manual
                details: [
                    {label: "Capacidad", value: "17.66 ft³"},
                    {label: "Temperatura", value: "0°C a 6°C"},
                    {label: "Voltaje", value: "220 V / 60 Hz"},
                    {label: "Medidas", value: "210 x 70 x 120 cm"}
                ],
                tags: ["Vitrina", "Deli", "Curvo", "Industrial"],
            },

            // VITRINAS PISO VIDRIO RECTO DEL
            {
                id: "gd-vfg-pr-90-3",
                name: "Vitrina Piso Vidrio Recto Deli GD-VFG-PR-90-3",
                brand: "Gelum",
                category: "Refrigeración",
                subcategory: "Vitrinas Piso Vidrio Recto Deli",
                price: 45501,
                description: "Vitrina refrigerada de piso con cristal recto, panel frontal anti neblina y control electrónico de temperatura. Iluminación LED interior.",
                whatsappProduct: "Gelum GD-VFG-PR-90-3",
                image: "/img/catalogo/GD-VFG-PR-90-3.webp",
                manualPdf: "",
                details: [
                    {label: "Capacidad", value: "12.7 ft³"},
                    {label: "Temperatura", value: "0°C a 6°C"},
                    {label: "Voltaje", value: "220 V / 60 Hz"},
                    {label: "Medidas", value: "90 x 70 x 120 cm"}
                ],
                tags: ["Vitrina", "Deli", "Recto"],
            },
            {
                id: "gd-vfg-pr-150-3",
                name: "Vitrina Piso Vidrio Recto Deli GD-VFG-PR-150-3",
                brand: "Gelum",
                category: "Refrigeración",
                subcategory: "Vitrinas Piso Vidrio Recto Deli",
                price: 57043,
                description: "Vitrina refrigerada de piso con mayor capacidad, cristal recto y control electrónico de temperatura. Iluminación LED interior.",
                whatsappProduct: "Gelum GD-VFG-PR-150-3",
                image: "/img/catalogo/GD-VFG-PR-150-3.webp",
                manualPdf: "",
                details: [
                    {label: "Capacidad", value: "19.4 ft³"},
                    {label: "Temperatura", value: "0°C a 6°C"},
                    {label: "Voltaje", value: "220 V / 60 Hz"},
                    {label: "Medidas", value: "150 x 70 x 120 cm"}
                ],
                tags: ["Vitrina", "Deli", "Recto", "Alta Capacidad"],
            },
            {
                id: "gd-vfg-pr-210-3",
                name: "Vitrina Piso Vidrio Recto Deli GD-VFG-PR-210-3",
                brand: "Gelum",
                category: "Refrigeración",
                subcategory: "Vitrinas Piso Vidrio Recto Deli",
                price: 64873,
                description: "Vitrina refrigerada de piso de gran formato con cristal recto, control electrónico e iluminación LED interior.",
                whatsappProduct: "Gelum GD-VFG-PR-210-3",
                image: "/img/catalogo/GD-VFG-PR-210-3.webp",
                manualPdf: "",
                details: [
                    {label: "Capacidad", value: "26.13 ft³"},
                    {label: "Temperatura", value: "0°C a 6°C"},
                    {label: "Voltaje", value: "220 V / 60 Hz"},
                    {label: "Medidas", value: "210 x 70 x 120 cm"}
                ],
                tags: ["Vitrina", "Deli", "Recto", "Industrial"],
            },
        ],
        pagina5: [
            //PAGINA 5
            // VITRINAS SOBREMOSTRADOR VIDRIO RECTO DELI
            {
                id: "gd-vfg-mr-66",
                name: "Vitrina Sobremostrador Vidrio Recto Deli GD-VFG-MR-66",
                brand: "Gelum",
                category: "Refrigeración",
                subcategory: "Vitrinas Sobremostrador Vidrio Recto Deli",
                price: 20387,
                description: "Vitrina refrigerada de sobremostrador con diseño recto, panel frontal anti neblina y control electrónico de temperatura. Iluminación LED interior.",
                whatsappProduct: "Gelum GD-VFG-MR-66",
                image: "/img/catalogo/GD-VFG-MR-66.webp", // Usando imagen de manuales ya que no hay en catálogo
                manualPdf: "/docs/manuales/GD-VFG-MR-66.webp", // Imagen usada como manual
                details: [
                    {label: "Capacidad", value: "3.00 ft³"},
                    {label: "Temperatura", value: "0°C a 6°C"},
                    {label: "Voltaje", value: "110 V / 60 Hz"},
                    {label: "Medidas", value: "66 x 53 x 73 cm"}
                ],
                tags: ["Vitrina", "Sobremostrador", "Recto"],
            },
            {
                id: "gd-vfg-mr-90",
                name: "Vitrina Sobremostrador Vidrio Recto Deli GD-VFG-MR-90",
                brand: "Gelum",
                category: "Refrigeración",
                subcategory: "Vitrinas Sobremostrador Vidrio Recto Deli",
                price: 21808,
                description: "Vitrina refrigerada de sobremostrador con mayor capacidad, diseño recto y control electrónico. Iluminación LED interior.",
                whatsappProduct: "Gelum GD-VFG-MR-90",
                image: "/img/catalogo/GD-VFG-MR-90.webp",
                manualPdf: "/docs/manuales/GD-VFG-MR-90.webp", // Imagen usada como manual
                details: [
                    {label: "Capacidad", value: "4.24 ft³"},
                    {label: "Temperatura", value: "0°C a 6°C"},
                    {label: "Voltaje", value: "110 V / 60 Hz"},
                    {label: "Medidas", value: "90 x 53 x 73 cm"}
                ],
                tags: ["Vitrina", "Sobremostrador", "Recto"],
            },
            {
                id: "gd-vfg-mr-120",
                name: "Vitrina Sobremostrador Vidrio Recto Deli GD-VFG-MR-120",
                brand: "Gelum",
                category: "Refrigeración",
                subcategory: "Vitrinas Sobremostrador Vidrio Recto Deli",
                price: 24940,
                description: "Vitrina refrigerada de sobremostrador de mayor formato con diseño recto y control electrónico. Iluminación LED interior.",
                whatsappProduct: "Gelum GD-VFG-MR-120",
                image: "/img/catalogo/GD-VFG-MR-120.webp",
                manualPdf: "",
                details: [
                    {label: "Capacidad", value: "5.65 ft³"},
                    {label: "Temperatura", value: "0°C a 6°C"},
                    {label: "Voltaje", value: "110 V / 60 Hz"},
                    {label: "Medidas", value: "120 x 53 x 73 cm"}
                ],
                tags: ["Vitrina", "Sobremostrador", "Recto", "Alta Capacidad"],
            },
            {
                id: "gd-vfg-mc-66",
                name: "Vitrina Sobremostrador Vidrio Curvo Deli GD-VFG-MC-66",
                brand: "Gelum",
                category: "Refrigeración",
                subcategory: "Vitrinas Sobremostrador Vidrio Curvo Deli",
                price: 20735,
                description: "Vitrina refrigerada de sobremostrador con diseño de cristal curvo, control electrónico de temperatura e iluminación LED interior.",
                whatsappProduct: "Gelum GD-VFG-MC-66",
                image: "/img/catalogo/GD-VFG-MC-66.webp",
                manualPdf: "",
                details: [
                    {label: "Capacidad", value: "3.00 ft³"},
                    {label: "Temperatura", value: "0°C a 6°C"},
                    {label: "Voltaje", value: "110 V / 60 Hz"},
                    {label: "Medidas", value: "66 x 53 x 73 cm"}
                ],
                tags: ["Vitrina", "Sobremostrador", "Curvo"],
            },
            {
                id: "gd-vfg-mc-90",
                name: "Vitrina Sobremostrador Vidrio Curvo Deli GD-VFG-MC-90",
                brand: "Gelum",
                category: "Refrigeración",
                subcategory: "Vitrinas Sobremostrador Vidrio Curvo Deli",
                price: 22214,
                description: "Vitrina refrigerada de sobremostrador con mayor capacidad y cristal curvo. Iluminación LED interior y control electrónico.",
                whatsappProduct: "Gelum GD-VFG-MC-90",
                image: "/img/catalogo/GD-VFG-MC-90.webp",
                manualPdf: "",
                details: [
                    {label: "Capacidad", value: "4.24 ft³"},
                    {label: "Temperatura", value: "0°C a 6°C"},
                    {label: "Voltaje", value: "110 V / 60 Hz"},
                    {label: "Medidas", value: "90 x 53 x 73 cm"}
                ],
                tags: ["Vitrina", "Sobremostrador", "Curvo"],
            },
            {
                id: "gd-vfg-mc-120",
                name: "Vitrina Sobremostrador Vidrio Curvo Deli GD-VFG-MC-120",
                brand: "Gelum",
                category: "Refrigeración",
                subcategory: "Vitrinas Sobremostrador Vidrio Curvo Deli",
                price: 24940,
                description: "Vitrina refrigerada de sobremostrador de gran formato con cristal curvo, control electrónico e iluminación LED interior.",
                whatsappProduct: "Gelum GD-VFG-MC-120",
                image: "/img/catalogo/GD-VFG-MC-120.webp",
                manualPdf: "",
                details: [
                    {label: "Capacidad", value: "5.65 ft³"},
                    {label: "Temperatura", value: "0°C a 6°C"},
                    {label: "Voltaje", value: "110 V / 60 Hz"},
                    {label: "Medidas", value: "120 x 53 x 73 cm"}
                ],
                tags: ["Vitrina", "Sobremostrador", "Curvo", "Alta Capacidad"],
            },
            {
                id: "desp-dbg-18-2",
                name: "Dispensador de Bebidas DBG-18-2",
                brand: "Gelum",
                category: "Cafetería-Bar",
                subcategory: "Bebidas",
                price: 14210,
                description: "Dispensador de bebidas no carbonatadas fabricado en acero inoxidable, con tazones removibles de grado alimenticio y fácil limpieza.",
                whatsappProduct: "Gelum DBG-18-2",
                image: "/img/catalogo/DBG-18-2.webp",
                manualPdf: "",
                details: [
                    {label: "Tazones", value: "2 x 18 L"},
                    {label: "Temperatura", value: "7°C a 12°C"},
                    {label: "Refrigerante", value: "R134A"},
                    {label: "Potencia", value: "280 W"},
                    {label: "Voltaje", value: "110 V / 60 Hz"},
                    {label: "Medidas", value: "48 x 56 x 74 cm"}
                ],
                tags: ["Dispensador", "Bebidas", "Doble"],
            },
            {
                id: "desp-dbg-18-3",
                name: "Dispensador de Bebidas DBG-18-3",
                brand: "Gelum",
                category: "Cafetería-Bar",
                subcategory: "Bebidas",
                price: 16472,
                description: "Dispensador de bebidas no carbonatadas con tres tazones removibles, diseñado para servicio continuo y fácil mantenimiento.",
                whatsappProduct: "Gelum DBG-18-3",
                image: "/img/catalogo/DBG-18-3.webp",
                manualPdf: "",
                details: [
                    {label: "Tazones", value: "3 x 18 L"},
                    {label: "Temperatura", value: "7°C a 12°C"},
                    {label: "Refrigerante", value: "R134A"},
                    {label: "Potencia", value: "380 W"},
                    {label: "Voltaje", value: "110 V / 60 Hz"},
                    {label: "Medidas", value: "70 x 43 x 74 cm"}
                ],
                tags: ["Dispensador", "Bebidas", "Triple"],
            },
            {
                id: "desp-dgg-10-1",
                name: "Dispensador de Granitas DGG-10-1",
                brand: "Gelum",
                category: "Cafetería-Bar",
                subcategory: "Bebidas",
                price: 30769,
                description: "Dispensador de granitas con un tazón, ideal para bebidas congeladas. Operación eficiente y fácil limpieza.",
                whatsappProduct: "Gelum DGG-10-1",
                image: "/img/catalogo/DGG-10-1.webp",
                manualPdf: "/docs/manuales/DGG-10-1.webp",
                details: [
                    {label: "Tazón", value: "1 x 10 L"},
                    {label: "Temperatura", value: "-10°C a -2°C"},
                    {label: "Voltaje", value: "110 V / 60 Hz"},
                    {label: "Medidas", value: "34 x 58 x 78 cm"}
                ],
                tags: ["Granitas", "Dispensador", "Simple"],
            },
            {
                id: "desp-dgg-10-2",
                name: "Dispensador de Granitas DGG-10-2",
                brand: "Gelum",
                category: "Cafetería-Bar",
                subcategory: "Bebidas",
                price: 40368,
                description: "Dispensador de granitas con dos tazones, ideal para alto flujo de servicio. Diseño robusto y fácil mantenimiento.",
                whatsappProduct: "Gelum DGG-10-2",
                image: "/img/catalogo/DGG-10-2.webp",
                manualPdf: "",
                details: [
                    {label: "Tazones", value: "2 x 10 L"},
                    {label: "Temperatura", value: "-2°C a -3°C"},
                    {label: "Potencia", value: "600 W"},
                    {label: "Voltaje", value: "110 V / 60 Hz"},
                    {label: "Medidas", value: "42 x 56 x 76 cm"}
                ],
                tags: ["Granitas", "Dispensador", "Doble"],
            },
            {
                id: "desp-dgg-10-3",
                name: "Dispensador de Granitas DGG-10-3",
                brand: "Gelum",
                category: "Cafetería-Bar",
                subcategory: "Bebidas",
                price: 50315,
                description: "Dispensador de granitas de alto volumen con tres tazones, diseñado para operación intensiva en cafeterías y bares.",
                whatsappProduct: "Gelum DGG-10-3",
                image: "/img/catalogo/DGG-10-3.webp",
                manualPdf: "",
                details: [
                    {label: "Tazones", value: "3 x 10 L"},
                    {label: "Temperatura", value: "-2°C a -3°C"},
                    {label: "Potencia", value: "800 W"},
                    {label: "Voltaje", value: "110 V / 60 Hz"},
                    {label: "Medidas", value: "60 x 56 x 76 cm"}
                ],
                tags: ["Granitas", "Dispensador", "Triple", "Industrial"],
            },
        ],
        pagina6: [
            //PAGINA 6
            {
                id: "gast-gp-ev-1ps-23",
                name: "Enfriador Profesional Puertas Sólidas GP-EV-1PS-23",
                brand: "GAST",
                category: "Equipos Profesionales",
                subcategory: "Enfriador Profesional Puertas Sólidas",
                price: 42485,
                description: "Enfriador profesional en acero inoxidable con control electrónico, iluminación LED, compresor ecológico R290 y bajo consumo energético.",
                whatsappProduct: "GAST GP-EV-1PS-23",
                image: "/img/catalogo/GAST-GP-EV-1PS-23.webp",
                manualPdf: "/docs/manuales/GAST-GP-EV-1PS-23.pdf",
                details: [
                    {label: "Capacidad", value: "24 ft³ (680 L)"},
                    {label: "Temperatura", value: "0°C a 5°C"},
                    {label: "Motor", value: "1/3 hp"},
                    {label: "Voltaje", value: "115 V / 60 Hz"},
                    {label: "Medidas", value: "76 x 75 x 202 cm"}
                ],
                tags: ["Enfriador", "Profesional", "Puerta Sólida"],
            },
            {
                id: "gast-gp-ev-2ps-49",
                name: "Enfriador Profesional Puertas Sólidas GP-EV-2PS-49",
                brand: "GAST",
                category: "Equipos Profesionales",
                subcategory: "Enfriador Profesional Puertas Sólidas",
                price: 62263,
                description: "Enfriador profesional de gran capacidad con puertas sólidas, iluminación LED y compresor ecológico R290.",
                whatsappProduct: "GAST GP-EV-2PS-49",
                image: "/img/catalogo/GP-EV-2PS-49.JPEG",
                manualPdf: "/docs/manuales/GAST-GP-EV-2PS-49.pdf",
                details: [
                    {label: "Capacidad", value: "49 ft³ (1388 L)"},
                    {label: "Temperatura", value: "0°C a 5°C"},
                    {label: "Motor", value: "1/3 hp"},
                    {label: "Voltaje", value: "115 V / 60 Hz"},
                    {label: "Medidas", value: "152 x 75 x 202 cm"}
                ],
                tags: ["Enfriador", "Profesional", "Alta Capacidad"],
            },
            {
                id: "gast-gp-cv-1ps-23",
                name: "Conservador de Congelados Puerta Sólida GP-CV-1PS-23",
                brand: "GAST",
                category: "Equipos Profesionales",
                subcategory: "Conservador de Congelados Puerta Sólida",
                price: 48952,
                description: "Congelador profesional en acero inoxidable con control electrónico, aislamiento en poliuretano y compresor ecológico R290.",
                whatsappProduct: "GAST GP-CV-1PS-23",
                image: "/img/catalogo/GAST-GP-CV-1PS-23.webp",
                manualPdf: "/docs/manuales/GAST-GP-CV-1PS-23.pdf",
                details: [
                    {label: "Capacidad", value: "24 ft³ (680 L)"},
                    {label: "Temperatura", value: "-23°C a -18°C"},
                    {label: "Motor", value: "1/2 hp"},
                    {label: "Voltaje", value: "115 V / 60 Hz"},
                    {label: "Medidas", value: "76 x 75 x 202 cm"}
                ],
                tags: ["Congelador", "Profesional", "Puerta Sólida"],
            },
            {
                id: "gast-gp-cv-2ps-49",
                name: "Conservador de Congelados Puerta Sólida GP-CV-2PS-49",
                brand: "GAST",
                category: "Equipos Profesionales",
                subcategory: "Conservador de Congelados Puerta Sólida",
                price: 73950,
                description: "Congelador profesional de gran capacidad con puertas sólidas, alto rendimiento y compresor ecológico R290.",
                whatsappProduct: "GAST GP-CV-2PS-49",
                image: "/img/catalogo/GAST-GP-CV-2PS-49.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Capacidad", value: "49 ft³ (1388 L)"},
                    {label: "Temperatura", value: "-23°C a -18°C"},
                    {label: "Motor", value: "1/2 hp"},
                    {label: "Voltaje", value: "115 V / 60 Hz"},
                    {label: "Medidas", value: "152 x 75 x 202 cm"}
                ],
                tags: ["Congelador", "Profesional", "Industrial"],
            },
            {
                id: "gast-gp-ev-1pv-23",
                name: "Enfriador Profesional Puertas de Cristal GP-EV-1PV-23",
                brand: "GAST",
                category: "Equipos Profesionales",
                subcategory: "Enfriadores Profesionales Puertas de Cristal",
                price: 45617,
                description: "Enfriador profesional con puertas de vidrio doble LOW-E, iluminación LED y compresor ecológico R290.",
                whatsappProduct: "GAST GP-EV-1PV-23",
                image: "/img/catalogo/GAST-GP-EV-1PV-23.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Capacidad", value: "24 ft³ (680 L)"},
                    {label: "Temperatura", value: "0°C a 4°C"},
                    {label: "Motor", value: "1/3 hp"},
                    {label: "Voltaje", value: "115 V / 60 Hz"},
                    {label: "Medidas", value: "76 x 75 x 202 cm"}
                ],
                tags: ["Enfriador", "Cristal", "Profesional"],
            },
            {
                id: "gast-gp-ev-2pv-49",
                name: "Enfriador Profesional Puertas de Cristal GP-EV-2PV-49",
                brand: "GAST",
                category: "Equipos Profesionales",
                subcategory: "Enfriadores Profesionales Puertas de Cristal",
                price: 68730,
                description: "Enfriador profesional de gran capacidad con puertas de cristal, iluminación LED y alto ahorro energético.",
                whatsappProduct: "GAST GP-EV-2PV-49",
                image: "/img/catalogo/GAST-GP-EV-2PV-49.webp",
                manualPdf: "/docs/manuales/GAST-GP-EV-2PV-49.pdf",
                details: [
                    {label: "Capacidad", value: "49 ft³ (1388 L)"},
                    {label: "Temperatura", value: "0°C a 4°C"},
                    {label: "Motor", value: "1/2 hp"},
                    {label: "Voltaje", value: "115 V / 60 Hz"},
                    {label: "Medidas", value: "152 x 75 x 202 cm"}
                ],
                tags: ["Enfriador", "Cristal", "Alta Capacidad"],
            },
            {
                id: "gast-gp-cv-1pv-23",
                name: "Conservador de Congelados Profesional Puertas de Cristal GP-CV-1PV-23",
                brand: "GAST",
                category: "Equipos Profesionales",
                subcategory: "Conservador de Congelados Profesionales Puertas de Cristal",
                price: 57884,
                description: "Congelador profesional con puertas de cristal, sistema de aire forzado, deshielo automático y compresor ecológico R290.",
                whatsappProduct: "GAST GP-CV-1PV-23",
                image: "/img/catalogo/GAST-GP-CV-1PV-23.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Capacidad", value: "24 ft³ (680 L)"},
                    {label: "Temperatura", value: "-23°C a -18°C"},
                    {label: "Motor", value: "1/2 hp"},
                    {label: "Voltaje", value: "115 V / 60 Hz"},
                    {label: "Medidas", value: "76 x 75 x 202 cm"}
                ],
                tags: ["Congelador", "Cristal", "Profesional"],
            },
            {
                id: "gast-gp-cv-2pv-49",
                name: "Conservador de Congelados Profesional Puertas de Cristal GP-CV-2PV-49",
                brand: "GAST",
                category: "Equipos Profesionales",
                subcategory: "Conservador de Congelados Profesionales Puertas de Cristal",
                price: 87928,
                description: "Congelador profesional de gran volumen con puertas de cristal, aire forzado y deshielo automático.",
                whatsappProduct: "GAST GP-CV-2PV-49",
                image: "/img/catalogo/GAST-GP-CV-2PV-49.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Capacidad", value: "49 ft³ (1388 L)"},
                    {label: "Temperatura", value: "-23°C a -18°C"},
                    {label: "Motor", value: "2 x 1/2 hp"},
                    {label: "Voltaje", value: "115 V / 60 Hz"},
                    {label: "Medidas", value: "152 x 75 x 202 cm"}
                ],
                tags: ["Congelador", "Cristal", "Industrial"],
            },
            {
                id: "gast-gp-me-1ps-07",
                name: "Mesa Refrigerada de Preparación GP-ME-1PS-07",
                brand: "GAST",
                category: "Equipos Profesionales",
                subcategory: "Mesas Refrigeradoras para Preparación Sandwich y Ensaladas",
                price: 31668,
                description: "Mesa refrigerada de preparación fabricada en acero inoxidable con control electrónico de temperatura, tapa aislada y compresor ecológico R290. Incluye tabla de corte y bandejas certificadas NSF.",
                whatsappProduct: "GAST GP-ME-1PS-07",
                image: "/img/catalogo/GAST-GP-ME-1PS-07.webp",
                manualPdf: "/docs/manuales/GAST-GP-ME-1PS-07.pdf",
                details: [
                    {label: "Configuración", value: "1 puerta / 8 bandejas"},
                    {label: "Capacidad", value: "7 ft³ (204 L)"},
                    {label: "Temperatura", value: "1°C a 4°C"},
                    {label: "Motor", value: "1/5 hp"},
                    {label: "Voltaje", value: "115 V / 60 Hz / 2.8 A"},
                    {label: "Medidas", value: "68 x 76 x 103 cm"}
                ],
                tags: ["Mesa Refrigerada", "Preparación", "Sandwich"],
            },
            {
                id: "gast-gp-me-2ps-14",
                name: "Mesa Refrigerada de Preparación GP-ME-2PS-14",
                brand: "GAST",
                category: "Equipos Profesionales",
                subcategory: "Mesas Refrigeradoras para Preparación Sandwich y Ensaladas",
                price: 46197,
                description: "Mesa refrigerada de preparación con dos puertas, tapa de acero inoxidable aislada y leaving bandejas certificadas NSF. Ideal para alto volumen de trabajo.",
                whatsappProduct: "GAST GP-ME-2PS-14",
                image: "/img/catalogo/GAST-GP-ME-2PS-14.webp",
                manualPdf: "/docs/manuales/GAST-GP-ME-2PS-14.pdf",
                details: [
                    {label: "Configuración", value: "2 puertas / 12 bandejas"},
                    {label: "Capacidad", value: "14 ft³ (388 L)"},
                    {label: "Temperatura", value: "1°C a 4°C"},
                    {label: "Motor", value: "1/4 hp"},
                    {label: "Voltaje", value: "115 V / 60 Hz / 2.6 A"},
                    {label: "Medidas", value: "121 x 76 x 103 cm"}
                ],
                tags: ["Mesa Refrigerada", "Preparación", "Alta Capacidad"],
            },
            {
                id: "gast-gp-me-2ps-18",
                name: "Mesa Refrigerada de Preparación GP-ME-2PS-18",
                brand: "GAST",
                category: "Equipos Profesionales",
                subcategory: "Mesas Refrigeradoras para Preparación Sandwich y Ensaladas",
                price: 54694,
                description: "Mesa refrigerada de preparación de gran capacidad con dos puertas, 16 bandejas certificadas NSF y compresor ecológico R290.",
                whatsappProduct: "GAST GP-ME-2PS-18",
                image: "/img/catalogo/GAST-GP-ME-2PS-18.webp",
                manualPdf: "/docs/manuales/GAST-GP-ME-2PS-18.pdf",
                details: [
                    {label: "Configuración", value: "2 puertas / 16 bandejas"},
                    {label: "Capacidad", value: "18 ft³ (495 L)"},
                    {label: "Temperatura", value: "1°C a 4°C"},
                    {label: "Motor", value: "1/3 hp"},
                    {label: "Voltaje", value: "115 V / 60 Hz / 3.7 A"},
                    {label: "Medidas", value: "152 x 76 x 103 cm"}
                ],
                tags: ["Mesa Refrigerada", "Preparación", "Industrial"],
            },
        ],
        pagina7: [
            //PAGINA 7
            // EQUIPOS PROFESIONALES --> MESAS DE TRABAJO REFRIGERADAS
            {
                id: "gast-gp-mt-rb-1ps-07",
                name: "Mesa de Trabajo Refrigerada GP-MT-RB-1PS-07",
                brand: "GAST",
                category: "Equipos Profesionales",
                subcategory: "Mesas de Trabajo Refrigeradas",
                price: 29725,
                description: "Mesa de trabajo refrigerada en acero inoxidable con control electrónico de temperatura, condensador de bajo mantenimiento y compresor ecológico R290.",
                whatsappProduct: "GAST GP-MT-RB-1PS-07",
                image: "/img/catalogo/GAST-GP-MT-RB-1PS-07.webp",
                manualPdf: "/docs/manuales/GAST-GP-MT-RB-1PS-07.pdf",
                details: [
                    {label: "Configuración", value: "1 puerta / 1 parrilla"},
                    {label: "Capacidad", value: "7 ft³ (204 L)"},
                    {label: "Temperatura", value: "1°C a 4°C"},
                    {label: "Motor", value: "1/6 hp"},
                    {label: "Voltaje", value: "115 V / 60 Hz / 1.6 A"},
                    {label: "Medidas", value: "68 x 76 x 88 cm"}
                ],
                tags: ["Mesa Refrigerada", "Trabajo", "Profesional"],
            },
            {
                id: "gast-gp-mt-rb-2ps-14",
                name: "Mesa de Trabajo Refrigerada GP-MT-RB-2PS-14",
                brand: "GAST",
                category: "Equipos Profesionales",
                subcategory: "Mesas de Trabajo Refrigeradas",
                price: 41354,
                description: "Mesa de trabajo refrigerada de dos puertas con mayor capacidad, control electrónico y compresor ecológico R290.",
                whatsappProduct: "GAST GP-MT-RB-2PS-14",
                image: "/img/catalogo/GAST-GP-MT-RB-2PS-14.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Configuración", value: "2 puertas / 2 parrillas"},
                    {label: "Capacidad", value: "14 ft³ (388 L)"},
                    {label: "Temperatura", value: "1°C a 4°C"},
                    {label: "Motor", value: "1/6 hp"},
                    {label: "Voltaje", value: "115 V / 60 Hz / 1.8 A"},
                    {label: "Medidas", value: "121 x 76 x 88 cm"}
                ],
                tags: ["Mesa Refrigerada", "Trabajo", "Alta Capacidad"],
            },
            {
                id: "gast-gp-mt-rb-2ps-18",
                name: "Mesa de Trabajo Refrigerada GP-MT-RB-2PS-18",
                brand: "GAST",
                category: "Equipos Profesionales",
                subcategory: "Mesas de Trabajo Refrigeradas",
                price: 46052,
                description: "Mesa de trabajo refrigerada de gran capacidad con dos puertas, control electrónico y compresor ecológico R290.",
                whatsappProduct: "GAST GP-MT-RB-2PS-18",
                image: "/img/catalogo/GAST-GP-MT-RB-2PS-18.webp",
                manualPdf: "/docs/manuales/GAST-GP-MT-RB-2PS-18.pdf",
                details: [
                    {label: "Configuración", value: "2 puertas / 2 parrillas"},
                    {label: "Capacidad", value: "18 ft³ (495 L)"},
                    {label: "Temperatura", value: "1°C a 4°C"},
                    {label: "Motor", value: "1/6 hp"},
                    {label: "Voltaje", value: "115 V / 60 Hz / 1.7 A"},
                    {label: "Medidas", value: "152 x 76 x 88 cm"}
                ],
                tags: ["Mesa Refrigerada", "Trabajo", "Industrial"],
            },
            {
                id: "gast-gp-mt-cb-1ps-07",
                name: "Mesa de Trabajo Congelada GP-MT-CB-1PS-07",
                brand: "GAST",
                category: "Equipos Profesionales",
                subcategory: "Mesas de Trabajo Congeladas",
                price: 33640,
                description: "Mesa de trabajo congelada en acero inoxidable con control electrónico de temperatura, aislamiento en poliuretano y compresor ecológico R290.",
                whatsappProduct: "GAST GP-MT-CB-1PS-07",
                image: "/img/catalogo/GAST-GP-MT-CB-1PS-07.webp",
                manualPdf: "/docs/manuales/GAST-GP-MT-CB-1PS-07.pdf",
                details: [
                    {label: "Configuración", value: "1 puerta / 1 parrilla"},
                    {label: "Capacidad", value: "7 ft³ (204 L)"},
                    {label: "Temperatura", value: "-21°C a -18°C"},
                    {label: "Motor", value: "1/5 hp"},
                    {label: "Voltaje", value: "115 V / 60 Hz / 1.6 A"},
                    {label: "Medidas", value: "68 x 76 x 88 cm"}
                ],
                tags: ["Mesa Congelada", "Trabajo", "Profesional"],
            },
            {
                id: "gast-gp-mt-cb-2ps-14",
                name: "Mesa de Trabajo Congelada GP-MT-CB-2PS-14",
                brand: "GAST",
                category: "Equipos Profesionales",
                subcategory: "Mesas de Trabajo Congeladas",
                price: 46603,
                description: "Mesa de trabajo congelada de dos puertas con control electrónico y compresor ecológico R290.",
                whatsappProduct: "GAST GP-MT-CB-2PS-14",
                image: "/img/catalogo/GP-MT-CB-2PS-14.webp",
                manualPdf: "/docs/manuales/GAST-GP-MT-CB-2PS-14.pdf",
                details: [
                    {label: "Configuración", value: "2 puertas / 2 parrillas"},
                    {label: "Capacidad", value: "14 ft³ (388 L)"},
                    {label: "Temperatura", value: "-21°C a -18°C"},
                    {label: "Motor", value: "1/3 hp"},
                    {label: "Voltaje", value: "115 V / 60 Hz / 2.2 A"},
                    {label: "Medidas", value: "121 x 76 x 88 cm"}
                ],
                tags: ["Mesa Congelada", "Trabajo", "Alta Capacidad"],
            },
            {
                id: "gast-gp-mt-cb-2ps-18",
                name: "Mesa de Trabajo Congelada GP-MT-CB-2PS-18",
                brand: "GAST",
                category: "Equipos Profesionales",
                subcategory: "Mesas de Trabajo Congeladas",
                price: 51620,
                description: "Mesa de trabajo congelada de gran capacidad con dos puertas, aislamiento reforzado y compresor ecológico R290.",
                whatsappProduct: "GAST GP-MT-CB-2PS-18",
                image: "/img/catalogo/GP-MT-CB-2PS-18.webp",
                manualPdf: "",
                details: [
                    {label: "Configuración", value: "2 puertas / 2 parrillas"},
                    {label: "Capacidad", value: "18 ft³ (495 L)"},
                    {label: "Temperatura", value: "-21°C a -18°C"},
                    {label: "Motor", value: "1/3 hp"},
                    {label: "Voltaje", value: "115 V / 60 Hz / 3.8 A"},
                    {label: "Medidas", value: "152 x 76 x 88 cm"}
                ],
                tags: ["Mesa Congelada", "Trabajo", "Industrial"],
            },
        ],
        pagina8: [
            //PAGINA 8
            // CARNICERÍA - SIERRAS - MOLINOS --> SIERRA DE PISO / MESA
            {
                id: "sier-kbr-116-2hp",
                name: "Sierra de Piso KBR-116-2HP",
                brand: "GAST",
                category: "Carnicería",
                subcategory: "Sierra de Piso / Mesa",
                price: 55042,
                description: "Sierra de piso con mesa y carro fabricados en acero inoxidable grado alimenticio. Altura máxima de corte de 40 cm para cinta de 116\".",
                whatsappProduct: "GAST KBR-116-2HP",
                image: "/img/catalogo/SIER-KBR-116-2HP.webp",
                manualPdf: "/docs/manuales/gast-kbr-116-2hp.pdf",
                details: [
                    {label: "Velocidad", value: "55 rpm"},
                    {label: "Motor", value: "2 hp"},
                    {label: "Voltaje", value: "127 V / 60 Hz"},
                    {label: "Medidas", value: "82 x 96 x 185 cm"}
                ],
                tags: ["Sierra", "Carnicería", "Industrial"],
            },
            {
                id: "sier-kbr-65ai",
                name: "Sierra de Piso KBR-65AI",
                brand: "GAST",
                category: "Carnicería",
                subcategory: "Sierra de Piso / Mesa",
                price: 17893,
                description: "Sierra compacta con cinta de 1660 mm, ideal para cortes precisos en carnicería.",
                whatsappProduct: "GAST KBR-65AI",
                image: "/img/catalogo/SIER-KBR-65AI.webp",
                manualPdf: "/docs/manuales/gast-kbr-65ai.pdf",
                details: [
                    {label: "Cinta", value: "1660 mm"},
                    {label: "Motor", value: "1 hp"},
                    {label: "Voltaje", value: "127 V / 60 Hz"},
                    {label: "Medidas", value: "46 x 47 x 88 cm"}
                ],
                tags: ["Sierra", "Carnicería"],
            },
            // CARNES
            {
                id: "moli-m1275",
                name: "Molino de Carnes M1275",
                brand: "GAST",
                category: "Carnicería",
                subcategory: "Carnes",
                price: 25346,
                description: "Molino de alto rendimiento con cuerpo y charola en acero inoxidable. Incluye navaja y cedazo.",
                whatsappProduct: "GAST M1275",
                image: "/img/catalogo/MOLI-M1275.webp",
                manualPdf: "/docs/manuales/MOLI-M1275.pdf",
                details: [
                    {label: "Motor", value: "1 hp"},
                    {label: "Transmisión", value: "2 engranes"},
                    {label: "Voltaje", value: "127 V / 60 Hz"},
                    {label: "Cabezal", value: "Aluminio"},
                    {label: "Medidas", value: "32.5 x 65 x 42 cm"}
                ],
                tags: ["Molino", "Carnes"],
            },
            {
                id: "moli-m900",
                name: "Molino de Carnes M900",
                brand: "GAST",
                category: "Carnicería",
                subcategory: "Carnes",
                price: 21953,
                description: "Molino de carnes compacto con transmisión de dos engranes y cabezal de aluminio.",
                whatsappProduct: "GAST M900",
                image: "/img/catalogo/MOLI-M900.webp",
                manualPdf: "/docs/manuales/MOLI-M900.pdf",
                details: [
                    {label: "Motor", value: "3/4 hp"},
                    {label: "Transmisión", value: "2 engranes"},
                    {label: "Voltaje", value: "127 V / 60 Hz"},
                    {label: "Cabezal", value: "Aluminio"},
                    {label: "Medidas", value: "32.5 x 63.5 x 42 cm"}
                ],
                tags: ["Molino", "Carnes"],
            },
            // CHORICERO
            {
                id: "moli-m2201-1hp",
                name: "Molino Choricero M2201-1HP",
                brand: "GAST",
                category: "Carnicería",
                subcategory: "Choricero",
                price: 30044,
                description: "Molino choricero con cuerpo en acero inoxidable y transmisión de 4 engranes. Incluye navaja y cedazo.",
                whatsappProduct: "GAST M2201-1HP",
                image: "/img/catalogo/MOL-M2201-1HP.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Motor", value: "1 hp"},
                    {label: "Transmisión", value: "4 engranes a 194 rpm"},
                    {label: "Voltaje", value: "127 V / 60 Hz"},
                    {label: "Gabinete", value: "Acero inoxidable 430"},
                    {label: "Medidas", value: "36 x 73 x 49 cm"}
                ],
                tags: ["Molino", "Choricero"],
            },
            {
                id: "moli-m2201-2hp",
                name: "Molino Choricero M2201-2HP",
                brand: "GAST",
                category: "Carnicería",
                subcategory: "Choricero",
                price: 36975,
                description: "Molino choricero de mayor potencia, diseñado para operación continua.",
                whatsappProduct: "GAST M2201-2HP",
                image: "/img/catalogo/MOLI-M2201-2HP.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Motor", value: "2 hp"},
                    {label: "Transmisión", value: "4 engranes a 194 rpm"},
                    {label: "Voltaje", value: "127 V / 60 Hz"},
                    {label: "Gabinete", value: "Acero inoxidable 430"},
                    {label: "Medidas", value: "36 x 73 x 49 cm"}
                ],
                tags: ["Molino", "Choricero", "Alta Potencia"],
            },
            // USO RUDO
            {
                id: "moli-m3800-mono-3hp",
                name: "Molino Uso Rudo M3800 Mono 3HP",
                brand: "GAST",
                category: "Carnicería",
                subcategory: "Uso Rudo",
                price: 80127,
                description: "Molino industrial de alta capacidad, diseñado para uso rudo continuo. Incluye navaja y cedazo.",
                whatsappProduct: "GAST M3800 MONO 3HP",
                image: "/img/catalogo/MOLI-M3800-MONO-3HP.webp",
                manualPdf: "/docs/manuales/MOLI-M3800-MONO-3HP.pdf",
                details: [
                    {label: "Motor", value: "3 hp"},
                    {label: "Voltaje", value: "220 V / 60 Hz"},
                    {label: "Cabezal", value: "Fierro fundido estañado"},
                    {label: "Capacidad", value: "Hasta 800 kg diarios"},
                    {label: "Medidas", value: "45 x 105 x 65 cm"}
                ],
                tags: ["Molino", "Uso Rudo", "Industrial"],
            },
            {
                id: "moli-m3800-tri-3hp",
                name: "Molino Uso Rudo M3800 Trifásico 3HP",
                brand: "GAST",
                category: "Carnicería",
                subcategory: "Uso Rudo",
                price: 78097,
                description: "Molino industrial trifásico para alto rendimiento y operación continua.",
                whatsappProduct: "GAST M3800 TRI 3HP",
                image: "/img/catalogo/MOLI-M3800-TRI-3HP.webp",
                manualPdf: "/docs/manuales/MOLI-M3800-MONO-3HP.pdf",
                details: [
                    {label: "Motor", value: "3 hp"},
                    {label: "Voltaje", value: "221 V / 60 Hz trifásico"},
                    {label: "Cabezal", value: "Fierro fundido estañado"},
                    {label: "Medidas", value: "45 x 105 x 65 cm"}
                ],
                tags: ["Molino", "Uso Rudo", "Trifásico"],
            },
            {
                id: "moli-m3800-tri-5hp",
                name: "Molino Uso Rudo M3800 Trifásico 5HP",
                brand: "GAST",
                category: "Carnicería",
                subcategory: "Uso Rudo",
                price: 90712,
                description: "Molino industrial trifásico de máxima potencia para producción intensiva.",
                whatsappProduct: "GAST M3800 TRI 5HP",
                image: "/img/catalogo/MOLI-3800-MONO-5HP.webp",
                manualPdf: "/docs/manuales/MOLI-3800-MONO-3HP-5HP.pdf",
                details: [
                    {label: "Motor", value: "5 hp"},
                    {label: "Voltaje", value: "222 V / 60 Hz trifásico"},
                    {label: "Cabezal", value: "Fierro fundido estañado"},
                    {label: "Medidas", value: "45 x 105 x 65 cm"}
                ],
                tags: ["Molino", "Uso Rudo", "Alta Potencia"],
            },
            // CARNICERÍA - REBANADORAS --> USO COMERCIAL
            {
                id: "reba-rs-250",
                name: "Rebanadora RS-250",
                brand: "Sanitary",
                category: "Carnicería",
                subcategory: "Rebanadoras Uso Comercial",
                price: 7482,
                description: "Rebanadora comercial equipada con cuchilla de acero al cromo y afilador integrado. Ideal para salchichonería.",
                whatsappProduct: "Sanitary RS-250",
                image: "/img/catalogo/REBA-RS-250.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Cuchilla", value: "250 mm (350 rpm)"},
                    {label: "Grosor", value: "0 a 15 mm"},
                    {label: "Motor", value: "1/4 hp"},
                    {label: "Voltaje", value: "110 V / 60 Hz"},
                    {label: "Medidas", value: "44 x 36 x 36 cm"}
                ],
                tags: ["Rebanadora", "Comercial"],
            },
            {
                id: "reba-rs-300",
                name: "Rebanadora RS-300",
                brand: "Sanitary",
                category: "Carnicería",
                subcategory: "Rebanadoras Uso Comercial",
                price: 10150,
                description: "Rebanadora comercial con cuchilla de mayor diámetro, afilador integrado y ajuste de grosor preciso.",
                whatsappProduct: "Sanitary RS-300",
                image: "/img/catalogo/REBA-RS-300.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Cuchilla", value: "300 mm (310 rpm)"},
                    {label: "Grosor", value: "0 a 15 mm"},
                    {label: "Motor", value: "1/3 hp"},
                    {label: "Voltaje", value: "110 V / 60 Hz"},
                    {label: "Medidas", value: "59 x 49 x 44 cm"}
                ],
                tags: ["Rebanadora", "Comercial"],
            },
            // USO RUDO
            {
                id: "reba-rs-300-hd",
                name: "Rebanadora RS-300 HD",
                brand: "Sanitary",
                category: "Carnicería",
                subcategory: "Rebanadoras Uso Rudo",
                price: 17980,
                description: "Rebanadora tipo vela de uso rudo con cuchilla de acero al cromo, afilador integrado y botonera de seguridad.",
                whatsappProduct: "Sanitary RS-300 HD",
                image: "/img/catalogo/REBA-RS-300 HD.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Cuchilla", value: "330 mm (1400 rpm)"},
                    {label: "Grosor", value: "0 a 15 mm"},
                    {label: "Motor", value: "1/2 hp"},
                    {label: "Voltaje", value: "110 V / 60 Hz"},
                    {label: "Medidas", value: "59 x 49 x 44 cm"}
                ],
                tags: ["Rebanadora", "Uso Rudo"],
            },
            {
                id: "reba-rs-350-hd",
                name: "Rebanadora RS-350 HD",
                brand: "Sanitary",
                category: "Carnicería",
                subcategory: "Rebanadoras Uso Rudo",
                price: 30827,
                description: "Rebanadora de alto desempeño con cuchilla de gran diámetro, diseñada para trabajo continuo.",
                whatsappProduct: "Sanitary RS-350 HD",
                image: "/img/catalogo/REBA-RS-350 HD.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Cuchilla", value: "350 mm (350 rpm)"},
                    {label: "Grosor", value: "0 a 30 mm"},
                    {label: "Motor", value: "1/3 hp"},
                    {label: "Voltaje", value: "110 V / 60 Hz"},
                    {label: "Medidas", value: "59 x 49 x 62 cm"}
                ],
                tags: ["Rebanadora", "Uso Rudo", "Alta Capacidad"],
            },
        ],
        pagina9: [
            // PAGINA 9
            // CARNICERÍA - SIERRAS - MOLINOS --> USO RUDO
            {
                id: "reba-rs-350-cv",
                name: "Rebanadora RS-350 CV",
                brand: "Sanitary",
                category: "Carnicería",
                subcategory: "Rebanadoras Uso Rudo",
                price: 32016,
                description: "Rebanadora de uso rudo con diseño reforzado y cuchilla de acero al cromo.",
                whatsappProduct: "Sanitary RS-350 CV",
                image: "/img/catalogo/REBA-RS-350-CV.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Cuchilla", value: "350 mm (260 rpm)"},
                    {label: "Grosor", value: "0 a 15 mm"},
                    {label: "Motor", value: "1/2 hp"},
                    {label: "Voltaje", value: "110 V / 60 Hz"},
                    {label: "Medidas", value: "76 x 66 x 62 cm"}
                ],
                tags: ["Rebanadora", "Uso Rudo"],
            },

            // AUTOMÁTICAS
            {
                id: "reba-rs-360-a",
                name: "Rebanadora Automática RS-360-A",
                brand: "Sanitary",
                category: "Carnicería",
                subcategory: "Rebanadoras Automáticas",
                price: 77488,
                description: "Rebanadora automática con cuchilla cromada, afilador integrado y sistema de corte con movimiento automático.",
                whatsappProduct: "Sanitary RS-360-A",
                image: "/img/catalogo/REBA-RS-360-A.webp",
                manualPdf: "/docs/manuales/REBA-RS-360-A.pdf",
                details: [
                    {label: "Cuchilla", value: "360 mm (60 rpm)"},
                    {label: "Grosor", value: "0 a 25 mm"},
                    {label: "Motor", value: "2 x 3/4 hp"},
                    {label: "Voltaje", value: "220 V / 60 Hz"},
                    {label: "Temperatura", value: "-4°C a 2°C"},
                    {label: "Peso", value: "220 kg"},
                    {label: "Medidas", value: "100 x 71 x 137 cm"}
                ],
                tags: ["Rebanadora", "Automática", "Industrial"],
            },

            // COCI
            {
                id: "coci-ls-2",
                name: "Licuadora Industrial LS-2",
                brand: "COCI",
                category: "Cocina",
                subcategory: "Licuadoras y Procesadores",
                price: 5249,
                description: "Licuadora industrial con vaso de acero inoxidable T-304, rompeolas tipo Deep Cleft para resultados homogéneos.",
                whatsappProduct: "COCI LS-2",
                image: "/img/catalogo/COCI-LS-2.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Capacidad", value: "2 L"},
                    {label: "Motor", value: "1/2 hp"},
                    {label: "Voltaje", value: "127 V / 60 Hz"},
                    {label: "Peso", value: "4 kg"},
                    {label: "Medidas", value: "20 x 20 x 46 cm"}
                ],
                tags: ["Licuadora", "Industrial", "Cocina"],
            },
            {
                id: "coci-ls-3",
                name: "Licuadora Industrial LS-3",
                brand: "COCI",
                category: "Cocina",
                subcategory: "Licuadoras y Procesadores",
                price: 9657,
                description: "Licuadora industrial de mayor capacidad con vaso de acero inoxidable grado alimenticio.",
                whatsappProduct: "COCI LS-3",
                image: "/img/catalogo/COCI-LS-3.webp",
                manualPdf: "/docs/manuales/COCI-LS-3.pdf",
                details: [
                    {label: "Capacidad", value: "3 L"},
                    {label: "Motor", value: "1/2 hp"},
                    {label: "Voltaje", value: "127 V / 60 Hz"},
                    {label: "Peso", value: "16 kg"},
                    {label: "Medidas", value: "25 x 25 x 58 cm"}
                ],
                tags: ["Licuadora", "Industrial"],
            },
            {
                id: "coci-ls-5",
                name: "Licuadora Industrial LS-5",
                brand: "COCI",
                category: "Cocina",
                subcategory: "Licuadoras y Procesadores",
                price: 11542,
                description: "Licuadora industrial de alto desempeño con vaso T-304 y rompeolas optimizado.",
                whatsappProduct: "COCI LS-5",
                image: "/img/catalogo/COCI-LS-5.webp",
                manualPdf: "/docs/manuales/COCI-LS-5.pdf",
                details: [
                    {label: "Capacidad", value: "5 L"},
                    {label: "Motor", value: "3/4 hp"},
                    {label: "Voltaje", value: "127 V / 60 Hz"},
                    {label: "Peso", value: "18 kg"},
                    {label: "Medidas", value: "25 x 25 x 73 cm"}
                ],
                tags: ["Licuadora", "Industrial"],
            },
            {
                id: "coci-ls-10",
                name: "Licuadora Industrial LS-10",
                brand: "COCI",
                category: "Cocina",
                subcategory: "Licuadoras y Procesadores",
                price: 13021,
                description: "Licuadora industrial de gran capacidad para producción continua.",
                whatsappProduct: "COCI LS-10",
                image: "/img/catalogo/COCI-LS-10.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Capacidad", value: "10 L"},
                    {label: "Motor", value: "1 hp"},
                    {label: "Voltaje", value: "127 V / 60 Hz"},
                    {label: "Peso", value: "20 kg"},
                    {label: "Medidas", value: "25 x 25 x 80 cm"}
                ],
                tags: ["Licuadora", "Industrial", "Alta Capacidad"],
            },
            {
                id: "coci-ls-12",
                name: "Licuadora Industrial LS-12",
                brand: "COCI",
                category: "Cocina",
                subcategory: "Licuadoras y Procesadores",
                price: 14703,
                description: "Licuadora industrial robusta con vaso de acero inoxidable y alto torque.",
                whatsappProduct: "COCI LS-12",
                image: "/img/catalogo/COCI-LS-12.webp",
                manualPdf: "/docs/manuales/COCI-LS-12.pdf",
                details: [
                    {label: "Capacidad", value: "12 L"},
                    {label: "Motor", value: "1 1/2 hp"},
                    {label: "Voltaje", value: "127 V / 60 Hz"},
                    {label: "Peso", value: "21 kg"},
                    {label: "Medidas", value: "25 x 25 x 83 cm"}
                ],
                tags: ["Licuadora", "Industrial"],
            },
            {
                id: "coci-ls-17",
                name: "Licuadora Industrial LS-17",
                brand: "COCI",
                category: "Cocina",
                subcategory: "Licuadoras y Procesadores",
                price: 17226,
                description: "Licuadora industrial de máxima capacidad con vaso T-304 y rompeolas tipo troquelado.",
                whatsappProduct: "COCI LS-17",
                image: "/img/catalogo/COCI-LS-17.webp",
                manualPdf: "/docs/manuales/COCI-LS-17.pdf",
                details: [
                    {label: "Capacidad", value: "17 L"},
                    {label: "Motor", value: "1 1/2 hp"},
                    {label: "Voltaje", value: "127 V / 60 Hz"},
                    {label: "Peso", value: "22 kg"},
                    {label: "Medidas", value: "42 x 52 x 95 cm"}
                ],
                tags: ["Licuadora", "Industrial", "Producción"],
            },
            {
                id: "coci-ls-12-vp",
                name: "Licuadora Industrial LS-12-VP con Volteo",
                brand: "COCI",
                category: "Cocina",
                subcategory: "Licuadoras y Procesadores",
                price: 22243,
                description: "Licuadora industrial con sistema de volteo ergonómico y pedestal en acero inoxidable.",
                whatsappProduct: "COCI LS-12-VP",
                image: "/img/catalogo/COCI-LS-12-VP.webp",
                manualPdf: "/docs/manuales/COCI-LS-12-VP.pdf",
                details: [
                    {label: "Capacidad", value: "12 L"},
                    {label: "Motor", value: "1 1/2 hp"},
                    {label: "Voltaje", value: "127 V / 60 Hz"},
                    {label: "Peso", value: "25 kg"},
                    {label: "Medidas", value: "60 x 42 x 120 cm"}
                ],
                tags: ["Licuadora", "Volteo", "Industrial"],
            },
            {
                id: "coci-ls-17-vp",
                name: "Licuadora Industrial LS-17-VP con Volteo",
                brand: "COCI",
                category: "Cocina",
                subcategory: "Licuadoras y Procesadores",
                price: 23084,
                description: "Licuadora industrial de gran capacidad con sistema de volteo ergonómico para operación segura.",
                whatsappProduct: "COCI LS-17-VP",
                image: "/img/catalogo/COCI-LS-17-VP.webp",
                manualPdf: "/docs/manuales/COCI-LS-17-VP.pdf",
                details: [
                    {label: "Capacidad", value: "17 L"},
                    {label: "Motor", value: "1 1/2 hp"},
                    {label: "Voltaje", value: "127 V / 60 Hz"},
                    {label: "Peso", value: "30 kg"},
                    {label: "Medidas", value: "42 x 52 x 120 cm"}
                ],
                tags: ["Licuadora", "Volteo", "Industrial", "Alta Capacidad"],
            },
        ],
        pagina10: [

            // PAGINA 10
            // BÁSCULAS - ELECTRÓNICAS --> MOSTRADOR / MULTIFUNCIONALES
            {
                id: "basc-bms-40-usb",
                name: "Báscula Mostrador BMS-40-USB",
                brand: "BASC",
                category: "Básculas",
                subcategory: "Mostrador / Multifuncionales",
                price: 1479,
                description: "Báscula electrónica de mostrador con puerto USB, plato de acero inoxidable y batería recargable.",
                whatsappProduct: "BASC BMS-40-USB",
                image: "/img/catalogo/BASC-BMS-40-USB.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Precisión", value: "2 g"},
                    {label: "Peso máximo", value: "40 kg"},
                    {label: "Alimentación", value: "Eliminador y batería recargable"},
                    {label: "Unidades", value: "kg / lb"},
                    {label: "Material", value: "ABS / Charola acero inox"},
                    {label: "Medidas", value: "34 x 33 x 11 cm"}
                ],
                tags: ["Báscula", "Mostrador", "USB"],
            },
            {
                id: "basc-bms-40-eco",
                name: "Báscula Mostrador BMS-40-ECO",
                brand: "BASC",
                category: "Básculas",
                subcategory: "Mostrador / Multifuncionales",
                price: 754,
                description: "Báscula electrónica económica para mostrador con charola de acero inoxidable y batería recargable.",
                whatsappProduct: "BASC BMS-40-ECO",
                image: "/img/catalogo/BASC-BMS-40-ECO.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Clase", value: "Media"},
                    {label: "Precisión", value: "5 g"},
                    {label: "Peso máximo", value: "40 kg"},
                    {label: "Alimentación", value: "Eliminador y batería recargable"},
                    {label: "Unidades", value: "kg / lb"},
                    {label: "Material", value: "ABS / Charola acero inox"},
                    {label: "Medidas", value: "30 x 28 x 10 cm"}
                ],
                tags: ["Báscula", "Mostrador", "Económica"],
            },
            {
                id: "basc-bgs-03",
                name: "Báscula Gramera BGS-03",
                brand: "BASC",
                category: "Básculas",
                subcategory: "Mostrador / Multifuncionales",
                price: 522,
                description: "Báscula gramera de alta precisión para mostrador, con batería recargable.",
                whatsappProduct: "BASC BGS-03",
                image: "/img/catalogo/BASC-BGS-03.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Clase", value: "Fina II"},
                    {label: "Precisión", value: "0.1 g"},
                    {label: "Peso máximo", value: "3 kg"},
                    {label: "Alimentación", value: "Batería recargable"},
                    {label: "Unidades", value: "kg / lb / oz / g"},
                    {label: "Material", value: "ABS / Charola acero"},
                    {label: "Medidas", value: "16 x 23 x 5 cm"}
                ],
                tags: ["Báscula", "Gramera", "Precisión"],
            },
            {
                id: "basc-bgs-10",
                name: "Báscula Gramera BGS-10",
                brand: "BASC",
                category: "Básculas",
                subcategory: "Mostrador / Multifuncionales",
                price: 1334,
                description: "Báscula electrónica para mostrador con buena capacidad y batería recargable.",
                whatsappProduct: "BASC BGS-10",
                image: "/img/catalogo/BASC-BGS-10.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Clase", value: "Media III"},
                    {label: "Precisión", value: "1 g"},
                    {label: "Peso máximo", value: "10 kg"},
                    {label: "Alimentación", value: "Batería recargable"},
                    {label: "Unidades", value: "kg / lb / oz"},
                    {label: "Material", value: "ABS / Charola acero"},
                    {label: "Medidas", value: "30 x 32 x 11 cm"}
                ],
                tags: ["Báscula", "Mostrador"],
            },
            {
                id: "basc-bgs-300",
                name: "Báscula Gramera BGS-300",
                brand: "BASC",
                category: "Básculas",
                subcategory: "Mostrador / Multifuncionales",
                price: 348,
                description: "Báscula de precisión fina para pesajes pequeños, compacta y portátil.",
                whatsappProduct: "BASC BGS-300",
                image: "/img/catalogo/BASC-BGS-300.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Clase", value: "Fina III"},
                    {label: "Precisión", value: "0.01 g"},
                    {label: "Peso máximo", value: "300 g"},
                    {label: "Alimentación", value: "2 pilas AAA"},
                    {label: "Unidades", value: "g / oz / ct / gn / tl / pz"},
                    {label: "Material", value: "ABS / Charola acero inox"},
                    {label: "Medidas", value: "4.7 x 7.5 x 1.9 cm"}
                ],
                tags: ["Báscula", "Precisión", "Portátil"],
            },

            // COLGANTES / PLATAFORMAS
            {
                id: "basc-bps-150-m-ai",
                name: "Báscula Plataforma BPS-150-M-AI",
                brand: "BASC",
                category: "Básculas",
                subcategory: "Colgantes / Plataformas",
                price: 2407,
                description: "Báscula de plataforma con pantalla iluminada y charola de acero inoxidable.",
                whatsappProduct: "BASC BPS-150-M-AI",
                image: "/img/catalogo/BASC-BPS-150-M-AI.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Precisión", value: "20 g"},
                    {label: "Peso máximo", value: "150 kg"},
                    {label: "Alimentación", value: "Eliminador y batería recargable"},
                    {label: "Unidades", value: "kg / lb"},
                    {label: "Material", value: "Acero / Charola acero inox"},
                    {label: "Medidas", value: "30 x 55 x 76 cm"}
                ],
                tags: ["Báscula", "Plataforma"],
            },
            {
                id: "basc-bps-300-m-ai",
                name: "Báscula Plataforma BPS-300-M-AI",
                brand: "BASC",
                category: "Básculas",
                subcategory: "Colgantes / Plataformas",
                price: 3132,
                description: "Báscula de plataforma de mayor capacidad con batería recargable.",
                whatsappProduct: "BASC BPS-300-M-AI",
                image: "/img/catalogo/BASC-BPS-300-M-AI.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Precisión", value: "50 g"},
                    {label: "Peso máximo", value: "300 kg"},
                    {label: "Alimentación", value: "Eliminador y batería recargable"},
                    {label: "Unidades", value: "kg / lb"},
                    {label: "Material", value: "Acero / Charola acero inox"},
                    {label: "Medidas", value: "40 x 65 x 91 cm"}
                ],
                tags: ["Báscula", "Plataforma", "Alta Capacidad"],
            },
            {
                id: "basc-bps-500-m-ai",
                name: "Báscula Plataforma BPS-500-M-AI",
                brand: "BASC",
                category: "Básculas",
                subcategory: "Colgantes / Plataformas",
                price: 4089,
                description: "Báscula de plataforma industrial para cargas pesadas.",
                whatsappProduct: "BASC BPS-500-M-AI",
                image: "/img/catalogo/BASC-BPS-500-M-AI.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Precisión", value: "100 g"},
                    {label: "Peso máximo", value: "500 kg"},
                    {label: "Alimentación", value: "Eliminador y batería recargable"},
                    {label: "Unidades", value: "kg / lb"},
                    {label: "Material", value: "Acero / Charola acero inox"},
                    {label: "Medidas", value: "50 x 75 x 102 cm"}
                ],
                tags: ["Báscula", "Plataforma", "Industrial"],
            },

            // BÁSCULA PROFESIONAL
            {
                id: "basc-bps-600-m-ai",
                name: "Báscula Profesional BPS-600-M-AI",
                brand: "BASC",
                category: "Básculas",
                suffix: "M-AI",
                price: 6902,
                description: "Báscula profesional de alta capacidad con estructura reforzada y charola de acero inoxidable.",
                whatsappProduct: "BASC BPS-600-M-AI",
                image: "/img/catalogo/BASC-BPS-600-M-AI.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Precisión", value: "100 g"},
                    {label: "Peso máximo", value: "600 kg"},
                    {label: "Alimentación", value: "Eliminador y batería recargable"},
                    {label: "Unidades", value: "kg / lb"},
                    {label: "Material", value: "Acero / Charola acero inox"},
                    {label: "Medidas", value: "70 x 105 x 118.5 cm"}
                ],
                tags: ["Báscula", "Profesional", "Industrial"],
            },

            // COLGANTE
            {
                id: "basc-bcs-300-01",
                name: "Báscula Colgante BCS-300-01",
                brand: "BASC",
                category: "Básculas",
                subcategory: "Colgante",
                price: 1392,
                description: "Báscula colgante con dígitos grandes y carcasa de aluminio, ideal para uso rudo.",
                whatsappProduct: "BASC BCS-300-01",
                image: "/img/catalogo/BASC-BCS-300-01.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Precisión", value: "100 g"},
                    {label: "Peso máximo", value: "300 kg"},
                    {label: "Alimentación", value: "3 pilas AAA"},
                    {label: "Unidades", value: "kg / lb"},
                    {label: "Material", value: "Fundición aluminio / Gancho acero inox"},
                    {label: "Medidas", value: "16.5 x 4.5 x 27 cm"}
                ],
                tags: ["Báscula", "Colgante"],
            },
            {
                id: "basc-bcs-500",
                name: "Báscula Colgante BCS-500",
                brand: "BASC",
                category: "Básculas",
                subcategory: "Colgante",
                price: 2958,
                description: "Báscula colgante de alta capacidad con batería de larga duración.",
                whatsappProduct: "BASC BCS-500",
                image: "/img/catalogo/BASC-BCS-500.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Precisión", value: "200 g"},
                    {label: "Peso máximo", value: "500 kg"},
                    {label: "Alimentación", value: "4 pilas AA + 2 AAA"},
                    {label: "Unidades", value: "kg / lb"},
                    {label: "Material", value: "Fundición aluminio / Gancho acero"},
                    {label: "Medidas", value: "16.5 x 4.5 x 27 cm"}
                ],
                tags: ["Báscula", "Colgante", "Alta Capacidad"],
            },
        ],
        pagina11: [
            //PAGINA 11
            // REBANADORA DE ENGRANES USO RUDO
            {
                id: "rhen-reba-300-iga",
                name: "Rebanadora de Engranes 300 IGA",
                brand: "Rheninghaus",
                category: "Carnicería",
                subcategory: "Rebanadoras de Engranes Uso Rudo",
                price: 48314,
                description: "Rebanadora de uso profesional fabricada en fundición de aluminio anodizado, con transmisión por engranes y afilador integrado.",
                whatsappProduct: "RHENINGHAUS REBA 300 IGA",
                image: "/img/catalogo/REBA-300-IGA.webp",
                manualPdf: "/docs/manuales/REBA-300-IGA.pdf",
                details: [
                    {label: "Diámetro cuchilla", value: "300 mm"},
                    {label: "Motor", value: "1/2 hp"},
                    {label: "Transmisión", value: "Engranes"},
                    {label: "Voltaje", value: "110 V / 60 Hz"},
                    {label: "Peso", value: "38 kg"},
                    {label: "Medidas", value: "62 x 46.5 x 46 cm"}
                ],
                tags: ["Rebanadora", "Uso Rudo", "Engranes"],
            },
            {
                id: "rhen-reba-350-iga",
                name: "Rebanadora de Engranes 350 IGA",
                brand: "Rheninghaus",
                category: "Carnicería",
                subcategory: "Rebanadoras de Engranes Uso Rudo",
                price: 61683,
                description: "Rebanadora industrial de alto rendimiento con transmisión por engranes y estructura robusta de aluminio anodizado.",
                whatsappProduct: "RHENINGHAUS REBA 350 IGA",
                image: "/img/catalogo/RHEN-REBA-350-IGA.webp",
                manualPdf: "/docs/manuales/RHEN-REBA-350-IGA.pdf",
                details: [
                    {label: "Diámetro cuchilla", value: "350 mm"},
                    {label: "Motor", value: "1/2 hp"},
                    {label: "Transmisión", value: "Engranes"},
                    {label: "Voltaje", value: "110 V / 60 Hz"},
                    {label: "Peso", value: "42 kg"},
                    {label: "Medidas", value: "62 x 46.5 x 46 cm"}
                ],
                tags: ["Rebanadora", "Uso Rudo", "Industrial"],
            },
            // REBANADORA DE BANDA USO RUDO
            {
                id: "rhen-reba-350-afm",
                name: "Rebanadora de Banda 350 AFM",
                brand: "Rheninghaus",
                category: "Carnicería",
                subcategory: "Rebanadoras de Banda Uso Rudo",
                price: 34278,
                description: "Rebanadora de banda con cuchilla de acero 100CR6, diseñada para cortes precisos y operación profesional.",
                whatsappProduct: "RHENINGHAUS REBA 350 AFM",
                image: "/img/catalogo/REBA-350-AFM.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Diámetro cuchilla", value: "350 mm"},
                    {label: "Motor", value: "1/2 hp"},
                    {label: "Transmisión", value: "Banda"},
                    {label: "Voltaje", value: "110 V / 60 Hz"},
                    {label: "Temperatura de rebanado", value: "0 a -5 °C"},
                    {label: "Material cuchilla", value: "Acero 100CR6"},
                    {label: "Material cuerpo", value: "Aluminio anodizado"},
                    {label: "Peso", value: "32 kg"},
                    {label: "Medidas", value: "55 x 43 x 47 cm"}
                ],
                tags: ["Rebanadora", "Banda", "Uso Rudo"],
            },

            // HORNOS DE MICROONDAS
            {
                id: "tk-tkl10tc",
                name: "Horno de Microondas Profesional TKL10TC",
                brand: "TekniKitchen",
                category: "Cocina",
                subcategory: "Hornos de Microondas",
                price: 7076,
                description: "Horno de microondas profesional con panel táctil braille, 5 niveles de potencia y programación de hasta 100 menús.",
                whatsappProduct: "TEKNIKITCHEN TKL10TC",
                image: "/img/catalogo/TKL10TC.webp",
                manualPdf: "/docs/manuales/TKL10TC.pdf",
                details: [
                    {label: "Potencia salida", value: "1000 W"},
                    {label: "Potencia consumo", value: "1500 W"},
                    {label: "Capacidad", value: "25 L (0.9 pies³)"},
                    {label: "Voltaje", value: "120 V / 60 Hz"},
                    {label: "Niveles de potencia", value: "5"},
                    {label: "Programas", value: "100 menús"},
                    {label: "Tiempo máximo", value: "60 min"},
                    {label: "Medidas", value: "59.5 x 49.2 x 40.7 cm"}
                ],
                tags: ["Microondas", "Profesional", "Cocina"],
            },
            {
                id: "tk-tkm10tc",
                name: "Horno de Microondas Profesional TKM10TC",
                brand: "TekniKitchen",
                category: "Cocina",
                subcategory: "Hornos de Microondas",
                price: 14239,
                description: "Microondas profesional de mayor capacidad con control táctil, sistema braille y cocción programable.",
                whatsappProduct: "TEKNIKITCHEN TKM10TC",
                image: "/img/catalogo/TKM10TC.webp",
                manualPdf: "/docs/manuales/TKM10TC.pdf",
                details: [
                    {label: "Potencia salida", value: "1000 W"},
                    {label: "Potencia consumo", value: "1600 W"},
                    {label: "Capacidad", value: "34 L (1.2 pies³)"},
                    {label: "Voltaje", value: "120 V / 60 Hz"},
                    {label: "Niveles de potencia", value: "5"},
                    {label: "Programas", value: "100 menús"},
                    {label: "Tiempo máximo", value: "60 min"},
                    {label: "Medidas", value: "64.6 x 55.9 x 44.6 cm"}
                ],
                tags: ["Microondas", "Profesional", "Alta Capacidad"],
            },
        ],
        pagina12: [
            // PAGINA 12
            // --- AMASADORAS ---
            {
                id: "diam-pana-amas-ad-20",
                name: "Amasadora AMAS AD-20",
                brand: "Diamantti",
                subcategory: "Amasadoras",
                description: "Amasadora de espiral en acero inoxidable con rejilla de seguridad y dos velocidades. Capacidad de producción de hasta 40 minutos consecutivos.",
                image: ["/img/catalogo/AMAS-AD-20.webp"],
                manualPdf: "/docs/manuales/AMAS-AD-20.pdf",
                details: [
                    {label: "Capacidad Tazón", value: "20 L"},
                    {label: "Masa Terminada", value: "8 kg"},
                    {label: "Motor", value: "2 hp"},
                    {label: "Medidas", value: "39 x 65 x 79 cm"}
                ]
            },
            {
                id: "diam-pana-amas-ad-40",
                name: "Amasadora AMAS AD-40",
                brand: "Diamantti",
                subcategory: "Amasadoras",
                description: "Equipo industrial de alto rendimiento para panadería, construido en acero inoxidable con sistemas de seguridad integrados.",
                image: ["/img/catalogo/AMAS-AD-40.webp"],
                manualPdf: "/docs/manuales/AMAS-AD-40.pdf",
                details: [
                    {label: "Capacidad Tazón", value: "40 L"},
                    {label: "Masa Terminada", value: "15 kg"},
                    {label: "Motor", value: "2 hp"},
                    {label: "Medidas", value: "44 x 75 x 88 cm"}
                ]
            },
            {
                id: "diam-pana-amas-ad-60",
                name: "Amasadora AMAS AD-60",
                brand: "Diamantti",
                subcategory: "Amasadoras",
                description: "Amasadora de gran capacidad para alta producción. Disponible en conexión 110V y 220V.",
                image: ["/img/catalogo/AMAS-AD-60.webp"],
                manualPdf: "",
                details: [
                    {label: "Capacidad Tazón", value: "60 L"},
                    {label: "Masa Terminada", value: "25 kg"},
                    {label: "Motor", value: "3 hp"},
                    {label: "Medidas", value: "53 x 88 x 92 cm"}
                ]
            },
            {
                // PRODUCTO RESALTADO EN TU IMAGEN
                id: "diam-pana-amas-ad-60-220v",
                name: "Amasadora AMAS AD-60 (220V)",
                brand: "Diamantti",
                subcategory: "Amasadoras",
                description: "Versión industrial de alto torque con conexión a 220V para una operación más eficiente en plantas de panificación.",
                image: ["/img/catalogo/AMAS-AD-60-220V.webp"],
                manualPdf: "",
                details: [
                    {label: "Tazón", value: "60 L"},
                    {label: "Masa Terminada", value: "25 kg"},
                    {label: "Motor", value: "3 hp"},
                    {label: "Voltaje", value: "220V / 60Hz / 1F"}
                ]
            },

            // --- BATIDORAS ---
            {
                id: "diam-pana-bati-bd-07",
                name: "Batidora BATI BD-07",
                brand: "Diamantti",
                subcategory: "Batidoras",
                description: "Batidora compacta con implementos intercambiables y selector de 10 velocidades.",
                image: ["/img/catalogo/BATI-BD-07.webp"],
                manualPdf: "/docs/manuales/BATI-BD-07.pdf",
                details: [
                    {label: "Capacidad Tazón", value: "7 L"},
                    {label: "Masa Terminada", value: "2 kg"},
                    {label: "Motor", value: "1/2 hp"},
                    {label: "Velocidades", value: "10"}
                ]
            },
            {
                id: "diam-pana-bati-bd-10",
                name: "Batidora BATI BD-10",
                brand: "Diamantti",
                subcategory: "Batidoras",
                description: "Batidora industrial con rejilla de seguridad y elevador de tazón manual.",
                image: "/img/catalogo/BATI-BD-10.webp",
                manualPdf: "/docs/manuales/BATI-BD-10.pdf",
                details: [
                    {label: "Capacidad Tazón", value: "10 L"},
                    {label: "Masa Terminada", value: "1 kg"},
                    {label: "Motor", value: "1/2 hp"},
                    {label: "Medidas", value: "36 x 44 x 65 cm"}
                ]
            },
            {
                id: "diam-pana-bati-bd-20",
                name: "Batidora BATI BD-20",
                brand: "Diamantti",
                subcategory: "Batidoras",
                description: "Potente batidora para repostería y panadería con selector de 3 velocidades.",
                image: "/img/catalogo/BATI-BD-20.webp",
                manualPdf: "/docs/manuales/BATI-BD-20.pdf",
                details: [
                    {label: "Capacidad Tazón", value: "20 L"},
                    {label: "Masa Terminada", value: "2-4 kg"},
                    {label: "Motor", value: "1.5 hp"},
                    {label: "Medidas", value: "43 x 50 x 76 cm"}
                ]
            },
            {
                id: "diam-pana-bati-bd-30",
                name: "Batidora BATI BD-30",
                brand: "Diamantti",
                subcategory: "Batidoras",
                description: "Batidora reforzada capaz de operar 40 minutos consecutivos bajo carga industrial.",
                image: "/img/catalogo/BATI-BD-30.webp",
                manualPdf: "/docs/manuales/BATI-BD-30.pdf",
                details: [
                    {label: "Capacidad Tazón", value: "30 L"},
                    {label: "Masa Terminada", value: "3-6 kg"},
                    {label: "Motor", value: "2 hp"},
                    {label: "Medidas", value: "43 x 47 x 88 cm"}
                ]
            },
            {
                id: "diam-pana-bati-bd-40",
                name: "Batidora BATI BD-40",
                brand: "Diamantti",
                subcategory: "Batidoras",
                description: "Batidora de alto desempeño para grandes volúmenes. Incluye batidor de globo, paleta y gancho en acero inoxidable.",
                image: "/img/catalogo/BATI-BD-40.webp",
                manualPdf: "/docs/manuales/BATI-BD-40.pdf",
                details: [
                    {label: "Capacidad Tazón", value: "40 L"},
                    {label: "Masa Terminada", value: "4-8 kg"},
                    {label: "Motor", value: "2.5 hp"},
                    {label: "Medidas", value: "63 x 64 x 101 cm"}
                ]
            },

            // --- COCINA / ROSTICEROS ---
            {
                id: "diam-coci-rost-rdm-27",
                name: "Rosticero COCI RDM-27",
                brand: "Diamantti",
                subcategory: "Rosticeros",
                description: "Uso con gas LP a baja presión. Incluye quemadores tipo flauta y puertas desmontables. (Compatible con Base BRD-27).",
                image: ["/img/catalogo/COCI-RDM-27.webp"],
                details: [
                    {label: "Capacidad", value: "27 pollos"},
                    {label: "Gas", value: "LP"},
                    {label: "Voltaje", value: "110V a 60Hz"},
                    {label: "Medidas", value: "145 x 44 x 102 cm"}
                ]
            },
            {
                id: "diam-coci-base-brd-27",
                name: "Base para Rosticero BASE BRD-27",
                brand: "Diamantti",
                subcategory: "Rosticeros",
                description: "Base de soporte industrial diseñada específicamente para el modelo COCI RDM-27.",
                image: ["/img/catalogo/BASE-BRD-27.webp"],
                details: [
                    {label: "Compatibilidad", value: "COCI RDM-27"},
                    {label: "Medidas", value: "145 x 44 cm"},
                    {label: "Uso", value: "Soporte reforzado"}
                ]
            },
            {
                id: "diam-coci-rost-rbd-45",
                name: "Rosticero COCI RBD-45",
                brand: "Diamantti",
                subcategory: "Rosticeros",
                description: "Rosticero de gran formato con lámparas internas para exhibición óptima.",
                image: ["/img/catalogo/COCI-RBD-45.webp"],
                details: [
                    {label: "Capacidad", value: "45 pollos"},
                    {label: "Gas", value: "LP"},
                    {label: "Medidas", value: "160 x 51 x 94 cm"},
                    {label: "Voltaje", value: "110V a 60Hz"}
                ]
            },

            // --- HORNOS PARA PIZZA ELÉCTRICOS ---
            {
                id: "diam-coci-horn-hpde-1",
                name: "Horno Pizza HORN HPDE-1",
                brand: "Diamantti",
                subcategory: "Hornos",
                description: "Horno eléctrico en acero inoxidable con piedra refractaria y control de temperatura independiente por nivel.",
                image: "/img/catalogo/HORN-HPDE-1.webp",
                manualPdf: "/docs/manuales/HORN-HPDE-1.pdf",
                details: [
                    {label: "Capacidad", value: "1 Charola"},
                    {label: "Temperatura", value: "50°C - 350°C"},
                    {label: "Potencia", value: "2 kW"},
                    {label: "Certificación", value: "IPX 68"}
                ]
            },
            {
                id: "diam-coci-horn-hpde-2",
                name: "Horno Pizza HORN HPDE-2",
                brand: "Diamantti",
                subcategory: "Hornos",
                description: "Horno de doble charola con termómetro analógico y manija de puerta cubierta para mayor seguridad.",
                image: "/img/catalogo/HORN-HPDE-2.webp",
                manualPdf: "/docs/manuales/HORN-HPDE-2-1.pdf",
                details: [
                    {label: "Capacidad", value: "2 Charolas"},
                    {label: "Temperatura", value: "50°C - 350°C"},
                    {label: "Potencia", value: "3 kW"},
                    {label: "Medidas", value: "51.5 x 62 x 48 cm"}
                ]
            },
        ],
        pagina13: [
            //PAG 13 Cortadora / Laminadora
            {
                id: "diamantti-pana-r-36",
                name: "Cortadora de Masa R-36",
                brand: "Diamantti",
                category: "Panadería",
                subcategory: "Cortadoras y Laminadoras",
                price: 14906,
                description: "Cortadora tradicional para masa con hojas de hierro colado y mecanismo de presión por engranes rectos.",
                whatsappProduct: "DIAMANTTI PANA R-36",
                image: "/img/catalogo/PANA-R-36.webp",
                manualPdf: "/docs/manuales/PANA-R-36.pdf",
                details: [
                    {label: "Uso", value: "Pesado"},
                    {label: "Divisiones", value: "36"},
                    {label: "Medidas", value: "38 x 43 x 60 cm"}
                ],
                tags: ["Cortadora", "Panadería", "Industrial"]
            },
            {
                id: "diamantti-pana-ldm-150",
                name: "Laminadora de Masa LDM-150",
                brand: "Diamantti",
                category: "Panadería",
                subcategory: "Cortadoras y Laminadoras",
                price: 68788,
                description: "Laminadora profesional para masa con amplio rango de laminado y motor de alto desempeño.",
                whatsappProduct: "DIAMANTTI PANA LDM-150",
                image: "/img/catalogo/PANA-LDM-150.webp",
                manualPdf: "/docs/manuales/PANA-LDM-150.pdf",
                details: [
                    {label: "Motor", value: "0.75 hp"},
                    {label: "Rango de laminado", value: "0.1 a 30 mm"},
                    {label: "Banda", value: "47 x 70 cm"},
                    {label: "Peso", value: "130 kg"},
                    {label: "Voltaje", value: "110 V / 60 Hz o 220 V / 60 Hz (3F)"},
                    {label: "Medidas", value: "170 x 90 x 165 cm"}
                ],
                tags: ["Laminadora", "Panadería", "Industrial"]
            },
            // Espigueros
            {
                id: "diamantti-pana-esp-20-alu",
                name: "Espiguero 20 Charolas Aluminio",
                brand: "Diamantti",
                category: "Panadería",
                subcategory: "Espigueros",
                price: 4611,
                description: "Espiguero desarmable fabricado en aluminio, ligero y resistente, con llantas para fácil desplazamiento.",
                whatsappProduct: "DIAMANTTI PANA ESP-20-ALU",
                image: "/img/catalogo/PANA-ESP-20 ALU.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Capacidad", value: "20 charolas de 45 x 65 cm"},
                    {label: "Medidas", value: "45 x 65 x 180 cm"}
                ],
                tags: ["Espiguero", "Panadería", "Aluminio"]
            },

            {
                id: "diamantti-pana-fe-18-n",
                name: "Espiguero Fornissimo 18 Charolas",
                brand: "Diamantti",
                category: "Panadería",
                subcategory: "Espigueros",
                price: 4060,
                description: "Espiguero fabricado en lámina negra resistente, con ruedas giratorias para fácil desplazamiento.",
                whatsappProduct: "DIAMANTTI PANA FE-18-N",
                image: "/img/catalogo/PANA-FE-18-N.png",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Capacidad", value: "18 charolas de 45 x 65 cm"},
                    {label: "Medidas", value: "52 x 66 x 193 cm"}
                ],
                tags: ["Espiguero", "Panadería", "Fornissimo"]
            },
            {
                id: "diamantti-pana-fe-36-n",
                name: "Espiguero Fornissimo 36 Charolas",
                brand: "Diamantti",
                category: "Panadería",
                subcategory: "Espigueros",
                price: 6264,
                description: "Espiguero de gran capacidad fabricado en lámina negra resistente para uso profesional.",
                whatsappProduct: "DIAMANTTI PANA FE-36-N",
                image: "/img/catalogo/PANA-FE-36-N.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Capacidad", value: "36 charolas de 45 x 65 cm"},
                    {label: "Medidas", value: "52 x 66 x 193 cm"}
                ],
                tags: ["Espiguero", "Panadería", "Alta Capacidad"]
            },
            // Fermentadora de Pan
            {
                id: "diamantti-pana-ferm-fde-16",
                name: "Fermentadora de Pan FDE-16",
                brand: "Diamantti",
                category: "Panadería",
                subcategory: "Fermentadoras",
                price: 18357,
                description: "Fermentadora profesional con control de humedad y ventilación de alta potencia para panadería.",
                whatsappProduct: "DIAMANTTI PANA FERM FDE-16",
                image: "/img/catalogo/PANA-FERM-FDE-16.webp",
                manualPdf: "/docs/manuales/",
                details: [
                    {label: "Temperatura de operación", value: "25°C a 85°C"},
                    {label: "Capacidad", value: "15 charolas"},
                    {label: "Humedad", value: "Ambiente a 85%"},
                    {label: "Potencia", value: "2.6 kW"},
                    {label: "Voltaje", value: "220 V / 60 Hz / 16A / 1 fase"},
                    {label: "Medidas", value: "50 x 73 x 188 cm"}
                ],
                tags: ["Fermentadora", "Panadería", "Profesional"]
            },
        ],
        pagina14: [
            // PAG 14 panaderia
            // --- AMASADORAS ---
            {
                id: "kacier-pana-amas-ak-08",
                name: "Amasadora AMAS AK-08",
                brand: "Kacier",
                category: "Panadería",
                subcategory: "Amasadoras",
                price: 15022,
                description: "Amasadora construida en aluminio o acero inoxidable 304 grado alimenticio con rejilla de protección.",
                whatsappProduct: "KACIER PANA AMAS-AK-08",
                image: "/img/catalogo/AMAS-AK-08.webp",
                manualPdf: "/docs/manuales/AMAS-AK-08.pdf",
                details: [
                    {label: "Potencia", value: "1 hp"},
                    {label: "Capacidad tazón", value: "8L"},
                    {label: "Masa terminada", value: "3 kg"},
                    {label: "Voltaje", value: "110V a 60Hz"},
                    {label: "Medidas", value: "30.2 x 49.5 x 38.5 cm"}
                ],
                tags: ["Amasadora", "Panadería", "Industrial"]
            },
            {
                id: "kacier-pana-amas-ak-20",
                name: "Amasadora AMAS AK-20",
                brand: "Kacier",
                category: "Panadería",
                subcategory: "Amasadoras",
                price: 18560,
                description: "Amasadora de 20L con sistema robusto de 4 engranajes para operación estable y duradera.",
                whatsappProduct: "KACIER PANA AMAS-AK-20",
                image: "/img/catalogo/AMAS-AK-20.webp",
                manualPdf: "/docs/manuales/AMAS-AK-20.pdf",
                details: [
                    {label: "Potencia", value: "1.5 hp"},
                    {label: "Capacidad tazón", value: "20L"},
                    {label: "Masa terminada", value: "8 kg"},
                    {label: "Voltaje", value: "110V a 60Hz"},
                    {label: "Medidas", value: "40.9 x 66.8 x 86.4 cm"}
                ],
                tags: ["Amasadora", "Panadería", "Industrial"]
            },
            {
                id: "kacier-pana-amas-ak-40-1.5",
                name: "Amasadora AMAS AK-40 1.5",
                brand: "Kacier",
                category: "Panadería",
                subcategory: "Amasadoras",
                price: 26448,
                description: "Amasadora industrial de alta capacidad con botón de reversa y rejilla protectora.",
                whatsappProduct: "KACIER PANA AMAS-AK-40/1.5",
                image: "/img/catalogo/AMAS-AK-40-1.5.webp",
                manualPdf: "/docs/manuales/AMAS-AK-40-1.5.pdf",
                details: [
                    {label: "Potencia", value: "2 hp"},
                    {label: "Capacidad tazón", value: "40L"},
                    {label: "Masa terminada", value: "16 kg"},
                    {label: "Voltaje", value: "110V a 60Hz"},
                    {label: "Medidas", value: "49 x 75.4 x 104.3 cm"}
                ],
                tags: ["Amasadora", "Panadería", "Industrial"]
            },
            {
                id: "kacier-pana-amas-ak-50",
                name: "Amasadora AMAS AK-50",
                brand: "Kacier",
                category: "Panadería",
                subcategory: "Amasadoras",
                price: 30914,
                description: "Amasadora industrial potente de 50L con sistema de 4 engranajes y reversa.",
                whatsappProduct: "KACIER PANA AMAS-AK-50",
                image: "/img/catalogo/AMAS-AK-50.webp",
                manualPdf: "/docs/manuales/AMAS-AK-50.pdf",
                details: [
                    {label: "Potencia", value: "4 hp"},
                    {label: "Capacidad tazón", value: "50L"},
                    {label: "Masa terminada", value: "20 kg"},
                    {label: "Voltaje", value: "220V a 60Hz"},
                    {label: "Medidas", value: "52 x 79.4 x 104.3 cm"}
                ],
                tags: ["Amasadora", "Panadería", "Industrial"]
            },

            // --- BATIDORAS ---
            {
                id: "kacier-pana-bati-bk-07",
                name: "Batidora BATI BK-07",
                brand: "Kacier",
                category: "Panadería",
                subcategory: "Batidoras",
                price: 9135,
                description: "Batidora con tazón de acero inoxidable 304 o aluminio grado alimenticio y movimiento planetario.",
                whatsappProduct: "KACIER PANA BATI-BK-07",
                image: "/img/catalogo/BATI-BK-07.webp",
                manualPdf: "/docs/manuales/BATI-BK-07.pdf",
                details: [
                    {label: "Potencia", value: "1/2 hp"},
                    {label: "Capacidad tazón", value: "7L"},
                    {label: "Masa terminada", value: "0.6 kg"},
                    {label: "Velocidades", value: "10"},
                    {label: "Peso", value: "16 kg"},
                    {label: "Medidas", value: "41.2 x 23.5 x 43 cm"}
                ],
                tags: ["Batidora", "Panadería", "Equipo"]
            },
            {
                id: "kacier-pana-bati-bk-08",
                name: "Batidora BATI BK-08",
                brand: "Kacier",
                category: "Panadería",
                subcategory: "Batidoras",
                price: 13224,
                description: "Batidora planetaria con sistema de 4 engranajes para mezclas uniformes.",
                whatsappProduct: "KACIER PANA BATI-BK-08",
                image: "/img/catalogo/BATI-BK-08.webp",
                manualPdf: "/docs/manuales/BATI-BK-08.pdf",
                details: [
                    {label: "Potencia", value: "1/2 hp"},
                    {label: "Capacidad tazón", value: "8L"},
                    {label: "Masa terminada", value: "1.5 kg"},
                    {label: "Velocidades", value: "3"},
                    {label: "Peso", value: "21 kg"},
                    {label: "Medidas", value: "36.2 x 44.2 x 59.5 cm"}
                ],
                tags: ["Batidora", "Panadería", "Industrial"]
            },
            {
                id: "kacier-pana-bati-bk-10",
                name: "Batidora BATI BK-10",
                brand: "Kacier",
                category: "Panadería",
                subcategory: "Batidoras",
                price: 13920,
                description: "Batidora industrial de 10L con rejilla protectora y construcción robusta.",
                whatsappProduct: "KACIER PANA BATI-BK-10",
                image: "/img/catalogo/BATI-BK-10.webp",
                manualPdf: "/docs/manuales/BATI-BK-10.pdf",
                details: [
                    {label: "Potencia", value: "1/2 hp"},
                    {label: "Capacidad tazón", value: "10L"},
                    {label: "Masa terminada", value: "1.5 kg"},
                    {label: "Velocidades", value: "3"},
                    {label: "Peso", value: "57 kg"},
                    {label: "Medidas", value: "46.7 x 46.7 x 61.5 cm"}
                ],
                tags: ["Batidora", "Panadería", "Industrial"]
            },
            {
                id: "kacier-pana-bati-bk-20",
                name: "Batidora BATI BK-20",
                brand: "Kacier",
                category: "Panadería",
                subcategory: "Batidoras",
                price: 17168,
                description: "Batidora de 20L ideal para producción industrial constante.",
                whatsappProduct: "KACIER PANA BATI-BK-20",
                image: "/img/catalogo/BATI-BK-20.webp",
                manualPdf: "/docs/manuales/BATI-BK-20.pdf",
                details: [
                    {label: "Potencia", value: "1 hp"},
                    {label: "Capacidad tazón", value: "20L"},
                    {label: "Masa terminada", value: "4.5 kg"},
                    {label: "Velocidades", value: "3"},
                    {label: "Peso", value: "76 kg"},
                    {label: "Medidas", value: "53.5 x 48.5 x 78 cm"}
                ],
                tags: ["Batidora", "Panadería", "Industrial"]
            },
            {
                id: "kacier-pana-bati-bk-30",
                name: "Batidora BATI BK-30",
                brand: "Kacier",
                category: "Panadería",
                subcategory: "Batidoras",
                price: 23200,
                description: "Batidora de alta capacidad (30L) para uso pesado en panaderías.",
                whatsappProduct: "KACIER PANA BATI-BK-30",
                image: "/img/catalogo/BATI-BK-30.webp",
                manualPdf: "/docs/manuales/BATI-BK-30.pdf",
                details: [
                    {label: "Potencia", value: "1 1/2 hp"},
                    {label: "Capacidad tazón", value: "30L"},
                    {label: "Masa terminada", value: "5.25 kg"},
                    {label: "Velocidades", value: "3"},
                    {label: "Peso", value: "84 kg"},
                    {label: "Medidas", value: "56 x 50 x 85.5 cm"}
                ],
                tags: ["Batidora", "Panadería", "Industrial"]
            },

            // --- CARNICERÍA ---
            {
                id: "kacier-carn-sier-sk-116",
                name: "Sierra SIER SK-116",
                brand: "Kacier",
                category: "Carnicería",
                subcategory: "Sierras",
                price: 52461,
                description: "Sierra con construcción de lámina de acero con pintura horneada, mesa y carro de acero inoxidable 304.",
                whatsappProduct: "KACIER CARN SIER-SK-116",
                image: "/img/catalogo/SIER-SK-116.webp",
                manualPdf: "/docs/manuales/SIER-SK-116.pdf",
                details: [
                    {label: "Motor", value: "1.5 hp"},
                    {label: "Cinta", value: "116\""},
                    {label: "Velocidad", value: "55 rpm"},
                    {label: "Voltaje", value: "127 V a 60 Hz"},
                    {label: "Medidas", value: "90 x 50 x 176 cm"}
                ],
                tags: ["Sierra", "Carnicería", "Industrial"]
            },
        ],
        pagina15: [
            //Pag 15
            // Molinos Carnicerias
            {
                id: "kacier-moli-mk-12",
                name: "Molino MK-12",
                brand: "KACIER",
                category: "Carnicería",
                subcategory: "Molinos",
                price: 21228,
                description: "Molino de carne con transmisión de 2 engranes y cuerpo en acero inoxidable, diseñado para uso eficiente y limpieza sencilla.",
                whatsappProduct: "KACIER MOLI MK-12",
                image: "/img/catalogo/MOLI-MK-12.webp",
                manualPdf: "/docs/manuales/MOLI-MK-12.pdf",
                details: [
                    {label: "Motor", value: "3/4 hp"},
                    {label: "Transmisión", value: "2 engranes"},
                    {label: "Medidas", value: "22 x 31 x 39 cm"}
                ],
                tags: ["Molino", "Carnicería", "Industrial"]
            },
            {
                id: "kacier-moli-mk-22",
                name: "Molino MK-22",
                brand: "KACIER",
                category: "Carnicería",
                subcategory: "Molinos",
                price: 25027,
                description: "Molino de carne con motor de 1 hp y transmisión de 2 engranes para trabajo continuo.",
                whatsappProduct: "KACIER MOLI MK-22",
                image: "/img/catalogo/MOLI-MK-22.webp",
                manualPdf: "/docs/manuales/MOLI-MK-22.pdf",
                details: [
                    {label: "Motor", value: "1 hp"},
                    {label: "Transmisión", value: "2 engranes"},
                    {label: "Medidas", value: "22 x 31 x 39 cm"}
                ],
                tags: ["Molino", "Carnicería", "Industrial"]
            },
            {
                id: "kacier-moli-mk-22-hd-1hp",
                name: "Molino MK-22 HD 1 HP",
                brand: "KACIER",
                category: "Carnicería",
                subcategory: "Molinos",
                price: 32480,
                description: "Molino de uso rudo con transmisión de 4 engranes para mayor durabilidad y rendimiento.",
                whatsappProduct: "KACIER MOLI MK-22-HD-1HP",
                image: "/img/catalogo/MOLI-MK-22-HD-1HP.webp",
                manualPdf: "/docs/manuales/MOLI-MK-22-HD-1HP.pdf",
                details: [
                    {label: "Motor", value: "1 hp"},
                    {label: "Transmisión", value: "4 engranes"},
                    {label: "Medidas", value: "33 x 71 x 43 cm"}
                ],
                tags: ["Molino", "Uso Rudo", "Carnicería"]
            },
            {
                id: "kacier-moli-mk-22-hd-2hp",
                name: "Molino MK-22 HD 2 HP",
                brand: "KACIER",
                category: "Carnicería",
                subcategory: "Molinos",
                price: 40194,
                description: "Molino industrial de alto rendimiento con motor de 2 hp y transmisión reforzada de 4 engranes.",
                whatsappProduct: "KACIER MOLI MK-22-HD-2HP",
                image: "/img/catalogo/MOLI-MK-22-HD-2HP.webp",
                manualPdf: "/docs/manuales/MOLI-MK-22-HD-2HP.pdf",
                details: [
                    {label: "Motor", value: "2 hp"},
                    {label: "Transmisión", value: "4 engranes"},
                    {label: "Medidas", value: "35 x 70 x 48 cm"}
                ],
                tags: ["Molino", "Uso Rudo", "Industrial"]
            },

// Salchichoneria

            {
                id: "kacier-reba-rk-250",
                name: "Rebanadora RK-250",
                brand: "KACIER",
                category: "Carnicería",
                subcategory: "Rebanadoras",
                price: 7482,
                description: "Rebanadora tipo vela con cuchilla de acero de alta durabilidad y ajuste preciso de grosor.",
                whatsappProduct: "KACIER REBA RK-250",
                image: "/img/catalogo/REBA-RK-250.webp",
                manualPdf: "/docs/manuales/REBA-RK-250.pdf",
                details: [
                    {label: "Diámetro cuchilla", value: "250 mm"},
                    {label: "Velocidad", value: "350 rpm"},
                    {label: "Grosor de corte", value: "0.2 a 12 mm"},
                    {label: "Motor", value: "1/4 hp"},
                    {label: "Peso", value: "17.7 kg"},
                    {label: "Medidas", value: "48 x 37 x 37 cm"}
                ],
                tags: ["Rebanadora", "Salchichonería", "Comercial"]
            },
            {
                id: "kacier-reba-rk-300",
                name: "Rebanadora RK-300",
                brand: "KACIER",
                category: "Carnicería",
                subcategory: "Rebanadoras",
                price: 10150,
                description: "Rebanadora industrial con cuchilla de 300 mm y motor de mayor potencia para cortes continuos.",
                whatsappProduct: "KACIER REBA RK-300",
                image: "/img/catalogo/REBA-RK-300.webp",
                manualPdf: "/docs/manuales/REBA-RK-300.pdf",
                details: [
                    {label: "Diámetro cuchilla", value: "300 mm"},
                    {label: "Velocidad", value: "300 rpm"},
                    {label: "Grosor de corte", value: "0.2 a 15 mm"},
                    {label: "Motor", value: "1/3 hp"},
                    {label: "Peso", value: "24.3 kg"},
                    {label: "Medidas", value: "51 x 44 x 43 cm"}
                ],
                tags: ["Rebanadora", "Salchichonería", "Industrial"]
            },

//Cafeteria

            {
                id: "kacier-desp-dbk-18-2",
                name: "Despachador de Bebidas DBK-18-2",
                brand: "KACIER",
                category: "Cafetería",
                subcategory: "Dispensadores de Bebidas",
                price: 14587,
                description: "Despachador de bebidas no carbonatadas con cuerpo en acero inoxidable y dos tazones desmontables.",
                whatsappProduct: "KACIER DESP DBK-18-2",
                image: "/img/catalogo/DESP-DBK-18-2.webp",
                manualPdf: "/docs/manuales/DESP-DBK-18-2.pdf",
                details: [
                    {label: "Tazones", value: "2 x 18 L"},
                    {label: "Temperatura", value: "7 a 12 °C"},
                    {label: "Refrigerante", value: "R134A"},
                    {label: "Potencia", value: "280 W"},
                    {label: "Voltaje", value: "110 V / 60 Hz"},
                    {label: "Medidas", value: "60 x 56 x 74 cm"}
                ],
                tags: ["Despachador", "Bebidas", "Cafetería"]
            },
            {
                id: "kacier-desp-dbk-18-3",
                name: "Despachador de Bebidas DBK-18-3",
                brand: "KACIER",
                category: "Cafetería",
                subcategory: "Dispensadores de Bebidas",
                price: 17864,
                description: "Despachador de bebidas no carbonatadas con tres tazones desmontables para mayor capacidad.",
                whatsappProduct: "KACIER DESP DBK-18-3",
                image: "/img/catalogo/DESP-DBK-18-3.webp",
                manualPdf: "/docs/manuales/DBK-18-3.pdf",
                details: [
                    {label: "Tazones", value: "3 x 18 L"},
                    {label: "Temperatura", value: "7 a 12 °C"},
                    {label: "Refrigerante", value: "R134A"},
                    {label: "Potencia", value: "380 W"},
                    {label: "Voltaje", value: "110 V / 60 Hz"},
                    {label: "Medidas", value: "70 x 43 x 74 cm"}
                ],
                tags: ["Despachador", "Bebidas", "Cafetería", "Alta Capacidad"]
            },
        ],
        pagina16: [
            // --- PANADERÍA: HORNOS (Pág. 16) ---
            {
                id: "kacier-pana-dp-hc-10",
                name: "Horno Turbo de Convección DP-HC-10",
                brand: "KACIER",
                category: "Panadería",
                subcategory: "Hornos",
                price: 103617,
                description: "Horno turbo de convección a gas en acero inoxidable con control digital de temperatura y vapor (hasta 260 °C), puerta con cristal templado y motor de 1 HP.",
                whatsappProduct: "KACIER PANA DP-HC-10",
                image: "/img/catalogo/DP-HC-10.webp",
                manualPdf: "/docs/manuales/DP-HC-10.pdf",
                // Nueva propiedad para manejar accesorios de forma independiente
                accessories: [
                    { id: "acc-riel-izq-der", name: "RIEL IZQ/DER", price: 261 },
                    { id: "acc-parr-55x60", name: "PARRHORPAST55X60", price: 1044 }
                ],
                details: [
                    { label: "Motor", value: "1 hp con ventilador" },
                    { label: "Consumo", value: "1.20kg/hr a 200°" },
                    { label: "Capacidad", value: "24 pares de espigas" },
                    { label: "Medidas", value: "100 x 136 x 188 cm" },
                    { label: "Combustible", value: "Gas" }
                ],
                tags: ["Horno", "Turbo", "Industrial"]
            },
            // --- AMASADORAS USO PESADO ---
            {
                id: "kacier-pana-amas-dp-am-pi-40",
                name: "Amasadora AMAS DP-AM-PI-40",
                brand: "KACIER",
                category: "Panadería",
                subcategory: "Amasadoras",
                price: 40716,
                description: "Amasadora de alta capacidad para procesos industriales de uso pesado (4 horas continuas).",
                whatsappProduct: "KACIER PANA AMAS-DP-AM-PI-40",
                image: "/img/catalogo/AMAS-DP-AM-PI-40.webp",
                manualPdf: "", // Reportado como faltante
                details: [
                    {label: "Potencia", value: "1.5 kW"},
                    {label: "Capacidad tazón", value: "40 Lts"},
                    {label: "Masa terminada", value: "15 kg"},
                    {label: "Medidas", value: "87.5 x 48.5 x 76.5 cm"}
                ],
                tags: ["Amasadora", "Uso Pesado", "Industrial"]
            },
            {
                id: "kacier-pana-amas-dp-am-es-50",
                name: "Amasadora AMAS DP-AM-ES-50",
                brand: "KACIER",
                category: "Panadería",
                subcategory: "Amasadoras",
                price: 89929,
                description: "Amasadora con transmisión por cadena y tazón de acero inoxidable.",
                whatsappProduct: "KACIER PANA AMAS-DP-AM-ES-50",
                image: "/img/catalogo/AMAS-DP-AM-ES-50.webp",
                manualPdf: "/docs/manuales/AMAS-DP-AM-ES-50.pdf",
                details: [
                    {label: "Potencia", value: "2.8 kW"},
                    {label: "Capacidad tazón", value: "50 Lts"},
                    {label: "Velocidad", value: "256/128 rpm"},
                    {label: "Medidas", value: "55 x 99 x 107 cm"}
                ],
                tags: ["Amasadora", "Uso Pesado", "Industrial"]
            },
            {
                id: "kacier-pana-amas-dp-am-es-80",
                name: "Amasadora AMAS DP-AM-ES-80",
                brand: "KACIER",
                category: "Panadería",
                subcategory: "Amasadoras",
                price: 116348,
                description: "Amasadora industrial de 80 Lts con sistema de banda de uso pesado.",
                whatsappProduct: "KACIER PANA AMAS-DP-AM-ES-80",
                image: "/img/catalogo/AMAS-DP-AM-ES-80.webp",
                manualPdf: "/docs/manuales/AMAS-DP-AM-ES-80.pdf",
                details: [
                    {label: "Potencia", value: "4.4 kW"},
                    {label: "Capacidad tazón", value: "80 Lts"},
                    {label: "Masa terminada", value: "25 kg"},
                    {label: "Medidas", value: "60.3 x 106.5 x 113 cm"}
                ],
                tags: ["Amasadora", "Uso Pesado", "Industrial"]
            },
            {
                id: "kacier-pana-amas-dp-am-es-130",
                name: "Amasadora AMAS DP-AM-ES-130",
                brand: "KACIER",
                category: "Panadería",
                subcategory: "Amasadoras",
                price: 145957,
                description: "Amasadora de alta potencia para producción masiva de masa terminada (50 kg).",
                whatsappProduct: "KACIER PANA AMAS-DP-AM-ES-130",
                image: "/img/catalogo/AMAS-DP-AM-ES-130.webp",
                manualPdf: "/docs/manuales/AMAS-DP-AM-ES-130.pdf",
                details: [
                    {label: "Potencia", value: "6.3 kW"},
                    {label: "Capacidad tazón", value: "130 Lts"},
                    {label: "Masa terminada", value: "50 kg"},
                    {label: "Medidas", value: "73 x 117.5 x 123 cm"}
                ],
                tags: ["Amasadora", "Uso Pesado", "Industrial"]
            },
            {
                id: "kacier-pana-amas-dp-am-es-200",
                name: "Amasadora AMAS DP-AM-ES-200",
                brand: "KACIER",
                category: "Panadería",
                subcategory: "Amasadoras",
                price: 198824,
                description: "El modelo de mayor capacidad de la línea con capacidad de 200 Lts en tazón.",
                whatsappProduct: "KACIER PANA AMAS-DP-AM-ES-200",
                image: "/img/catalogo/AMAS-DP-AM-ES-200.webp",
                manualPdf: "/docs/manuales/AMAS-DP-AM-ES-200.pdf",
                details: [
                    {label: "Potencia", value: "10.5 kW"},
                    {label: "Capacidad tazón", value: "200 Lts"},
                    {label: "Masa terminada", value: "75 kg"},
                    {label: "Medidas", value: "90.5 x 146 x 140 cm"}
                ],
                tags: ["Amasadora", "Uso Pesado", "Industrial"]
            },

// --- BATIDORAS USO PESADO ---
            {
                id: "kacier-pana-bati-dp-ba-hd-40",
                name: "Batidora BATI DP-BA-HD-40",
                brand: "KACIER",
                category: "Panadería",
                subcategory: "Batidoras",
                price: 54172,
                description: "Batidora de alto desempeño con 3 velocidades y batidor de acero inoxidable.",
                whatsappProduct: "KACIER PANA BATI-DP-BA-HD-40",
                // Cambiamos a un Array para soportar múltiples imágenes
                image: [
                    "/img/catalogo/BATI-DP-BA-HD-40-2.webp",
                    "/img/catalogo/BATI-DP-BA-HD-40-1.webp",
                    "/img/catalogo/BATI-DP-BA-HD-40-3.webp"
                ],
                manualPdf: "/docs/manuales/BATI-DP-BA-HD-40.pdf",
                details: [
                    {label: "Motor", value: "1 2/3 H.P."},
                    {label: "Capacidad tazón", value: "40 L"},
                    {label: "Masa terminada", value: "6 kg"},
                    {label: "Medidas", value: "63 x 63 x 101 cm"}
                ],
                tags: ["Batidora", "Uso Pesado", "Industrial"]
            },
            {
                id: "kacier-pana-bati-dp-ba-hd-60",
                name: "Batidora BATI DP-BA-HD-60",
                brand: "KACIER",
                category: "Panadería",
                subcategory: "Batidoras",
                price: 113042,
                description: "Batidora de 60 Lts diseñada para trabajo continuo de 4 horas.",
                whatsappProduct: "KACIER PANA BATI-DP-BA-HD-60",
                // Array con las imágenes adicionales encontradas en tu captura
                image: [
                    "/img/catalogo/BATI-DP-BA-HD-60-3.webp",
                    "/img/catalogo/BATI-DP-BA-HD-60-2.webp",
                ],
                manualPdf: "",
                details: [
                    {label: "Motor", value: "3 H.P."},
                    {label: "Capacidad tazón", value: "60 L"},
                    {label: "Masa terminada", value: "8 kg"},
                    {label: "Medidas", value: "72 x 65 x 130 cm"}
                ],
                tags: ["Batidora", "Uso Pesado", "Industrial"]
            },
            {
                id: "kacier-pana-bati-dp-ba-hd-100",
                name: "Batidora BATI DP-BA-HD-100",
                brand: "KACIER",
                category: "Panadería",
                subcategory: "Batidoras",
                price: 230753,
                description: "Batidora industrial de máxima capacidad (100 L) con motor de 3 3/4 H.P.",
                whatsappProduct: "KACIER PANA BATI-DP-BA-HD-100",
                image: "/img/catalogo/BATI-DP-BA-HD-100.webp",
                manualPdf: "", // Reportado como faltante
                details: [
                    {label: "Motor", value: "3 3/4 H.P."},
                    {label: "Capacidad tazón", value: "100 L"},
                    {label: "Masa terminada", value: "40 kg"},
                    {label: "Medidas", value: "74 x 102.5 x 160.2 cm"}
                ],
                tags: ["Batidora", "Uso Pesado", "Industrial"]
            },
            // --- LAMINADORAS ---
            {
                id: "kacier-pana-pana-dp-la-mb-163",
                name: "Laminadora PANA DP-LA-MB-163",
                brand: "KACIER",
                category: "Panadería",
                subcategory: "Laminadoras",
                price: 62437,
                description: "Laminadora con rodillo de cromo duro y cinta transportadora de grado alimenticio.",
                whatsappProduct: "KACIER PANA PANA-DP-LA-MB-163",
                image: "/img/catalogo/PANA-DP-LA-MB-163.webp",
                manualPdf: "/docs/manuales/PANA-DP-LA-MB-163.pdf",
                details: [
                    {label: "Motor", value: "1 H.P."},
                    {label: "Longitud rollo", value: "88 x 380 mm"},
                    {label: "Ajuste banda", value: "0-35 mm"},
                    {label: "Medidas", value: "73 x 163 x 122.5 cm"}
                ],
                tags: ["Laminadora", "Industrial", "Panadería"]
            },
            {
                id: "kacier-pana-pana-dp-la-mb-205",
                name: "Laminadora PANA DP-LA-MB-205",
                brand: "KACIER",
                category: "Panadería",
                subcategory: "Laminadoras",
                price: 67280,
                description: "Laminadora reforzada con mayor longitud de rollo (520 mm) y motor de 1 H.P.",
                whatsappProduct: "KACIER PANA PANA-DP-LA-MB-205",
                image: "/img/catalogo/PANA-DP-LA-MB-205.webp",
                manualPdf: "",
                details: [
                    {label: "Motor", value: "1 H.P."},
                    {label: "Longitud rollo", value: "88 x 520 mm"},
                    {label: "Ajuste banda", value: "0-35 mm"},
                    {label: "Medidas", value: "87 x 205 x 122.5 cm"}
                ],
                tags: ["Laminadora", "Industrial", "Panadería"]
            },
        ],
        pagina17: [
            //PAGINA 17
            {
                id: "ankor-mura-ap-mu-ra-258-100",
                name: "Mural Remoto Abierto MURA AP-MU-RA-258-100",
                brand: "ANKOR",
                category: "Refrigeración",
                subcategory: "Murales Remotos",
                price: 121017,
                description: "Mural remoto abierto con 4 repisas, espejo interior y cabeceras sólidas. Iluminación LED y operación de 0°C a 6°C.",
                whatsappProduct: "ANKOR MURA AP-MU-RA-258-100",
                image: "/img/catalogo/MURA-AP-MU-RA-258-100.webp",
                manualPdf: "",
                details: [
                    {label: "Capacidad", value: "92.5 ft³ (2,621 L)"},
                    {label: "Temperatura", value: "2°C a 8°C"},
                    {label: "Voltaje", value: "220V / 60Hz"},
                    {label: "Medidas", value: "258 x 100 x 208 cm"},
                    {label: "Peso bruto", value: "500 kg"}
                ],
                tags: ["Mural", "Refrigeración", "Supermercado"]
            },

            {
                id: "ankor-mura-ap-mu-ra-383-100",
                name: "Mural Remoto Abierto MURA AP-MU-RA-383-100",
                brand: "ANKOR",
                category: "Refrigeración",
                subcategory: "Murales Remotos",
                price: 172666,
                description: "Mural remoto abierto de gran capacidad con iluminación LED, espejo interior y operación de 0°C a 6°C.",
                whatsappProduct: "ANKOR MURA AP-MU-RA-383-100",
                image: "/img/catalogo/MURA-AP-MU-RA-383-100.webp",
                manualPdf: "",
                details: [
                    {label: "Capacidad", value: "155.3 ft³ (4,398 L)"},
                    {label: "Temperatura", value: "0°C a 6°C"},
                    {label: "Voltaje", value: "220V / 60Hz"},
                    {label: "Medidas", value: "383 x 100 x 208 cm"},
                    {label: "Peso bruto", value: "580 kg"}
                ],
                tags: ["Mural", "Refrigeración", "Supermercado"]
            },

            {
                id: "ankor-mura-ap-mu-rpv-258-100",
                name: "Mural Remoto con Puertas de Vidrio MURA AP-MU-RPV-258-100",
                brand: "ANKOR",
                category: "Refrigeración",
                subcategory: "Murales con Puertas",
                price: 170433,
                description: "Mural remoto con puertas de vidrio, iluminación LED y control de temperatura de -2°C a 4°C.",
                whatsappProduct: "ANKOR MURA AP-MU-RPV-258-100",
                image: "/img/catalogo/MURA-AP-MU-RPV-258-100.webp",
                manualPdf: "",
                details: [
                    {label: "Capacidad", value: "103.4 ft³ (2,928 L)"},
                    {label: "Temperatura", value: "-2°C a 4°C"},
                    {label: "Voltaje", value: "220V / 60Hz"},
                    {label: "Medidas", value: "258 x 100 x 208 cm"},
                    {label: "Peso bruto", value: "600 kg"}
                ],
                tags: ["Mural", "Puertas de Vidrio", "Supermercado"]
            },

            {
                id: "ankor-mura-ap-mu-rpv-383-100",
                name: "Mural Remoto con Puertas de Vidrio MURA AP-MU-RPV-383-100",
                brand: "ANKOR",
                category: "Refrigeración",
                subcategory: "Murales con Puertas",
                price: 246442,
                description: "Mural remoto de gran formato con puertas de vidrio y eficiencia térmica superior.",
                whatsappProduct: "ANKOR MURA AP-MU-RPV-383-100",
                image: "/img/catalogo/MURA-AP-MU-RPV-383-100.webp",
                manualPdf: "",
                details: [
                    {label: "Capacidad", value: "155.3 ft³ (4,398 L)"},
                    {label: "Temperatura", value: "-2°C a 4°C"},
                    {label: "Voltaje", value: "220V / 60Hz"},
                    {label: "Medidas", value: "383 x 100 x 208 cm"},
                    {label: "Peso bruto", value: "400 kg"}
                ],
                tags: ["Mural", "Puertas de Vidrio", "Refrigeración"]
            },

            {
                id: "ankor-vitr-ap-vi-rr-258",
                name: "Vitrina Remota Cuadrada Cerrada VITR AP-VI-RR-258",
                brand: "ANKOR",
                category: "Refrigeración",
                subcategory: "Vitrinas",
                price: 113622,
                description: "Vitrina remota cerrada con diseño cuadrado, acero inoxidable y operación de -3°C a 3°C.",
                whatsappProduct: "ANKOR VITR AP-VI-RR-258",
                image: "/img/catalogo/VITR-AP-VI-RR-258.webp",
                manualPdf: "/docs/manuales/VITR-AP-VI-RR-258.pdf",
                details: [
                    {label: "Capacidad", value: "14.4 ft³ (408 L)"},
                    {label: "Temperatura", value: "-3°C a 3°C"},
                    {label: "Voltaje", value: "220V / 60Hz"},
                    {label: "Medidas", value: "258 x 115 x 120 cm"}
                ],
                tags: ["Vitrina", "Refrigeración", "Exhibición"]
            },

            {
                id: "ankor-vitr-ap-vi-rr-383",
                name: "Vitrina Remota Cuadrada Cerrada VITR AP-VI-RR-383",
                brand: "ANKOR",
                category: "Refrigeración",
                subcategory: "Vitrinas",
                price: 165996,
                description: "Vitrina remota cerrada de gran formato con diseño cuadrado y alta eficiencia.",
                whatsappProduct: "ANKOR VITR AP-VI-RR-383",
                image: "/img/catalogo/VITR-AP-VI-RR-383.webp",
                manualPdf: "/docs/manuales/VITR-AP-VI-RR-383.pdf",
                details: [
                    {label: "Capacidad", value: "23.6 ft³ (668 L)"},
                    {label: "Temperatura", value: "-3°C a 3°C"},
                    {label: "Voltaje", value: "220V / 60Hz"},
                    {label: "Medidas", value: "383 x 115 x 89 cm"}
                ],
                tags: ["Vitrina", "Refrigeración", "Industrial"]
            },

            {
                id: "ankor-vitr-ap-vi-ra-258",
                name: "Vitrina Remota Cuadrada Abierta VITR AP-VI-RA-258",
                brand: "ANKOR",
                category: "Refrigeración",
                subcategory: "Vitrinas Abiertas",
                price: 84477,
                description: "Vitrina remota abierta con iluminación LED y excelente visibilidad de producto.",
                whatsappProduct: "ANKOR VITR AP-VI-RA-258",
                image: "/img/catalogo/VITR-AP-VI-RA-258.webp",
                manualPdf: "",
                details: [
                    {label: "Capacidad", value: "14.4 ft³ (408 L)"},
                    {label: "Temperatura", value: "-3°C a 3°C"},
                    {label: "Voltaje", value: "220V / 60Hz"},
                    {label: "Medidas", value: "258 x 115 x 89 cm"}
                ],
                tags: ["Vitrina", "Refrigeración", "Abierta"]
            },

            {
                id: "ankor-vitr-ap-vi-ra-383",
                name: "Vitrina Remota Cuadrada Abierta VITR AP-VI-RA-383",
                brand: "ANKOR",
                category: "Refrigeración",
                subcategory: "Vitrinas Abiertas",
                price: 125048,
                description: "Vitrina remota abierta de alta capacidad con iluminación LED.",
                whatsappProduct: "ANKOR VITR AP-VI-RA-383",
                image: "/img/catalogo/VITR-AP-VI-RA-383.webp",
                manualPdf: "",
                details: [
                    {label: "Capacidad", value: "23.6 ft³ (668 L)"},
                    {label: "Temperatura", value: "-3°C a 3°C"},
                    {label: "Voltaje", value: "220V / 60Hz"},
                    {label: "Medidas", value: "383 x 115 x 89 cm"}
                ],
                tags: ["Vitrina", "Refrigeración", "Exhibición"]
            },

            {
                id: "ankor-mura-ap-mu-aa-98-75",
                name: "Mural Autocontenido Abierto MURA AP-MU-AA-98-75",
                brand: "ANKOR",
                category: "Refrigeración",
                subcategory: "Murales Autocontenidos",
                price: 85260,
                description: "Mural autocontenido abierto con paneles laterales personalizables, iluminación LED y control de temperatura de alta eficiencia.",
                whatsappProduct: "ANKOR MURA AP-MU-AA-98-75",
                image: "/img/catalogo/MURA-AP-MU-AA-98-75.webp",
                manualPdf: [
                    {label: "Manual de Usuario", url: "/docs/manuales/MURA-AP-MU-AA-98-75-2.pdf"},
                    {label: "Ficha Técnica 1", url: "/docs/manuales/MURA-AP-MU-AA-98-75-1.pdf"},
                ],
                details: [
                    {label: "Capacidad", value: "22.9 ft³ (649 L)"},
                    {label: "Temperatura", value: "2°C a 8°C"},
                    {label: "Voltaje", value: "220V / 60Hz"},
                    {label: "Medidas", value: "98 x 75 x 208 cm"}
                ],
                tags: ["Mural", "Autocontenido", "Supermercado"]
            },

            {
                id: "ankor-mura-ap-mu-aa-133-75",
                name: "Mural Autocontenido Abierto MURA AP-MU-AA-133-75",
                brand: "ANKOR",
                category: "Refrigeración",
                subcategory: "Murales Autocontenidos",
                price: 92655,
                description: "Mural autocontenido abierto con repisas ajustables, iluminación LED y excelente visibilidad del producto.",
                whatsappProduct: "ANKOR MURA AP-MU-AA-133-75",
                image: "/img/catalogo/MURA-AP-MU-AA-133-75.webp",
                manualPdf: [
                    {label: "Manual de Usuario", url: "/docs/manuales/MURA-AP-MU-AA-133-75-2.pdf"},
                    {label: "Ficha Técnica 1", url: "/docs/manuales/MURA-AP-MU-AA-133-75-1.pdf"},
                ],
                details: [
                    {label: "Capacidad", value: "31.7 ft³ (898 L)"},
                    {label: "Temperatura", value: "2°C a 8°C"},
                    {label: "Voltaje", value: "220V / 60Hz"},
                    {label: "Medidas", value: "133 x 75 x 208 cm"}
                ],
                tags: ["Mural", "Autocontenido", "Refrigeración"]
            },

            {
                id: "ankor-mura-ap-mu-aa-195-100",
                name: "Mural Autocontenido Abierto MURA AP-MU-AA-195-100",
                brand: "ANKOR",
                category: "Refrigeración",
                subcategory: "Murales Autocontenidos",
                price: 118378,
                description: "Mural autocontenido abierto de gran capacidad, ideal para exhibición continua en supermercados.",
                whatsappProduct: "ANKOR MURA AP-MU-AA-195-100",
                image: "/img/catalogo/MURA-AP-MU-AA-195-100.webp",
                manualPdf: [
                    {label: "Manual de Usuario", url: "/docs/manuales/MURA-AP-MU-AA-195-100-2.pdf"},
                    {label: "Ficha Técnica 1", url: "/docs/manuales/MURA-AP-MU-AA-195-100-1.pdf"},
                ],
                details: [
                    {label: "Capacidad", value: "69.2 ft³ (1,960 L)"},
                    {label: "Temperatura", value: "2°C a 8°C"},
                    {label: "Voltaje", value: "220V / 60Hz"},
                    {label: "Medidas", value: "195 x 100 x 208 cm"}
                ],
                tags: ["Mural", "Autocontenido", "Supermercado"]
            },

            {
                id: "ankor-mura-ap-mu-aa-258-100",
                name: "Mural Autocontenido Abierto MURA AP-MU-AA-258-100",
                brand: "ANKOR",
                category: "Refrigeración",
                subcategory: "Murales Autocontenidos",
                price: 140563,
                description: "Mural autocontenido abierto de máxima capacidad con repisas ajustables y alta eficiencia energética.",
                whatsappProduct: "ANKOR MURA AP-MU-AA-258-100",
                image: "/img/catalogo/MURA-AP-MU-AA-258-100.webp",
                manualPdf: [
                    {label: "Manual de Usuario", url: "/docs/manuales/MURA-AP-MU-AA-258-100-2.pdf"},
                    {label: "Ficha Técnica 1", url: "/docs/manuales/MURA-AP-MU-AA-258-100-1.pdf"},
                ],
                details: [
                    {label: "Capacidad", value: "88 ft³ (2,490 L)"},
                    {label: "Temperatura", value: "2°C a 8°C"},
                    {label: "Voltaje", value: "220V / 60Hz"},
                    {label: "Medidas", value: "258 x 100 x 208 cm"}
                ],
                tags: ["Mural", "Autocontenido", "Refrigeración"]
            },
        ],
        pagina18: [
            // PAGINA 18 - SUPERMERCADOS - PUERTAS ANKOL
            // PUERTAS PARA CÁMARA DE REFRIGERACIÓN - MANERAL CORTO
            {
                id: "ankor-cama-ap-sp2-bn-jc-24-75",
                name: "Puerta para Cámara Maneral AP-SP2-BN-JC-24-75",
                brand: "Ankor",
                category: "Supermercados",
                subcategory: "Puertas para Cámara",
                price: 30160,
                description: "Puerta con triple cristal templado (congelación) con gas Argón al centro. Mecanismo que mantiene la puerta abierta a 90°. Cierre automático con gasket magnético para cierre hermético. Sistema de iluminación LED integrado. Configuración de apertura reversible. Color del marco: negro. Incluye estantería y parrillas (5 por nivel).",
                whatsappProduct: "ANKOR CAMA AP-SP2-BN-JC-24-75",
                image: "/img/catalogo/CAMA-AP-SP2-BN-JC-24-75.webp",
                manualPdf: "",
                details: [
                    {label: "Puertas", value: "2"},
                    {label: "Color", value: "Negro"},
                    {label: "Temperatura", value: "Congelación"},
                    {label: "Medidas", value: "24x75 pulgadas"},
                    {label: "Cristal", value: "Doble cristal templado | Marco calefactable"}
                ],
                tags: ["Puerta", "Cámara", "Congelación", "Ankor"]
            },
            {
                id: "ankor-cama-ap-sp3-bn-jc-24-75",
                name: "Puerta para Cámara Maneral AP-SP3-BN-JC-24-75",
                brand: "Ankor",
                category: "Supermercados",
                subcategory: "Puertas para Cámara",
                price: 45269,
                description: "Puerta con triple cristal templado (congelación) con gas Argón al centro. Mecanismo que mantiene la puerta abierta a 90°. Cierre automático con gasket magnético para cierre hermético. Sistema de iluminación LED integrado. Configuración de apertura reversible. Color del marco: negro. Incluye estantería y parrillas (5 por nivel).",
                whatsappProduct: "ANKOR CAMA AP-SP3-BN-JC-24-75",
                image: "/img/catalogo/CAMA-AP-SP3-BN-JC-24-75.webp",
                manualPdf: "",
                details: [
                    {label: "Puertas", value: "3"},
                    {label: "Color", value: "Negro"},
                    {label: "Temperatura", value: "Congelación"},
                    {label: "Medidas", value: "24x75 pulgadas"},
                    {label: "Cristal", value: "Triple cristal templado | Marco calefactable"}
                ],
                tags: ["Puerta", "Triple", "Congelación", "Ankor"]
            },

            // PUERTAS PARA CÁMARA DE REFRIGERACIÓN - MANERAL LARGO
            {
                id: "ankor-cama-ap-sp2-bn-jl-24-75",
                name: "Puerta para Cámara Maneral AP-SP2-BN-JL-24-75",
                brand: "Ankor",
                category: "Supermercados",
                subcategory: "Puertas para Cámara",
                price: 30160,
                description: "Puerta con triple cristal templado (congelación) con gas Argón al centro. Mecanismo que mantiene la puerta abierta a 90°. Cierre automático con gasket magnético para cierre hermético. Sistema de iluminación LED integrado. Configuración de apertura reversible. Color del marco: negro. Incluye estantería y parrillas (5 por nivel).",
                whatsappProduct: "ANKOR CAMA AP-SP2-BN-JL-24-75",
                image: "/img/catalogo/CAMA-AP-SP2-BN-JL-24-75.webp",
                manualPdf: "",
                details: [
                    {label: "Puertas", value: "2"},
                    {label: "Color", value: "Negro"},
                    {label: "Temperatura", value: "Congelación"},
                    {label: "Medidas", value: "24x75 pulgadas"},
                    {label: "Cristal", value: "Doble cristal templado | Marco calefactable"}
                ],
                tags: ["Puerta", "Maneral Largo", "Cámara", "Ankor"]
            },
            {
                id: "ankor-cama-ap-sp3-bn-jl-24-75",
                name: "Puerta para Cámara Maneral AP-SP3-BN-JL-24-75",
                brand: "Ankor",
                category: "Supermercados",
                subcategory: "Puertas para Cámara",
                price: 45269,
                description: "Puerta con triple cristal templado (congelación) con gas Argón al centro. Mecanismo que mantiene la puerta abierta a 90°. Cierre automático con gasket magnético para cierre hermético. Sistema de iluminación LED integrado. Configuración de apertura reversible. Color del marco: negro. Incluye estantería y parrillas (5 por nivel).",
                whatsappProduct: "ANKOR CAMA AP-SP3-BN-JL-24-75",
                image: "/img/catalogo/CAMA-AP-SP3-BN-JL-24-75.webp",
                manualPdf: "",
                details: [
                    {label: "Puertas", value: "3"},
                    {label: "Color", value: "Negro"},
                    {label: "Temperatura", value: "Congelación"},
                    {label: "Medidas", value: "24x75 pulgadas"},
                    {label: "Cristal", value: "Triple cristal templado | Marco calefactable"}
                ],
                tags: ["Puerta", "Maneral Largo", "Congelación", "Ankor"]
            },
        ],
        pagina19: [
            // PAGINA XX - LAVALOZAS - WINTERHALTER
            // LAVALOZAS - TAMAÑO DE CANASTILLAS: 40 x 40 cm
            {
                id: "winter-coci-lav-classeq-c3000",
                name: "Lavalozas coci-lav-classeq-c3000",
                brand: "Winterhalter",
                category: "Cocina",
                subcategory: "Lavalozas",
                price: 63104,
                description: "Construcción en acero inoxidable. Reduce hasta un 75% el consumo de agua, detergentes y costos de operación. Ideal para cubiertos, vajillas y vasos. Programas: Loza 1.5-2 min / Vidrio 2-3-5 min. Consumo agua: 2.75 L/ciclo.",
                whatsappProduct: "WINTERHALTER COCI LAV CLASSEQ C3000",
                image: "/img/catalogo/COCI-LAV-CLASSEQ-C3000.webp",
                manualPdf: "/docs/manuales/COCI-LAV-CLASSEQ-C3000.pdf",
                details: [
                    {label: "Capacidad tanque", value: "9.5 L"},
                    {label: "Consumo", value: "2.5 kW a 220V 1F / 6.5 kW a 220V 1F o 380V 3F"},
                    {label: "Medidas", value: "46 x 57 x 75 cm"},
                    {label: "Canastilla", value: "40 x 40 cm"},
                    {label: "Tanque aclarado", value: "6.5 L"}
                ],
                tags: ["Lavalozas", "Acero Inoxidable", "Winterhalter", "Ahorro de agua"]
            },
            {
                id: "winter-coci-lav-classeq-d6000",
                name: "Lavalozas coci-lav-classeq-d6000",
                brand: "Winterhalter",
                category: "Cocina",
                subcategory: "Lavalozas",
                price: 101790,
                description: "Construcción en acero inoxidable. Reduce hasta un 75% el consumo de agua, detergentes y costos de operación. Ideal para cubiertos, vajillas y vasos. Programas: 1.5/3/5 min. Consumo agua: 2.6 L/ciclo.",
                whatsappProduct: "WINTERHALTER COCI LAV CLASSEQ D6000",
                image: "/img/catalogo/COCI-LAV-CLASSEQ-D6000.webp",
                manualPdf: "/docs/manuales/COCI-LAV-CLASSEQ-D6000.pdf",
                details: [
                    {label: "Capacidad tanque", value: "14.3 L"},
                    {label: "Consumo", value: "6.8 kW a 230V 2F"},
                    {label: "Medidas", value: "57 x 60.5 x 86 cm"},
                    {label: "Canastilla", value: "40 x 40 cm"},
                    {label: "Tanque aclarado", value: "6.5 L"}
                ],
                tags: ["Lavalozas", "Eficiencia", "Winterhalter"]
            },

            // LAVALOZAS - TAMAÑO DE CANASTILLAS: 50 x 50 cm
            {
                id: "winter-coci-lav-classeq-d9000",
                name: "Lavalozas coci-lav-classeq-d9000",
                brand: "Winterhalter",
                category: "Cocina",
                subcategory: "Lavalozas",
                price: 158978,
                description: "Equipo amigable en su uso: solo dos botones permiten la operación completa. Capacidad: 39 L, construcción: Acero inoxidable, panel: LCD integrado (nueva mejora). Cumple con regulaciones de consumo de agua. Programas: 1.5/3/5 min.",
                whatsappProduct: "WINTERHALTER COCI LAV CLASSEQ D9000",
                image: "/img/catalogo/COCI-LAV-CLASSEQ-D9000.webp",
                manualPdf: "/docs/manuales/COCI-LAV-CLASSEQ-D9000.pdf",
                details: [
                    {label: "Capacidad tanque", value: "39 L"},
                    {label: "Consumo agua", value: "3 L/ciclo"},
                    {label: "Consumo", value: "6.68 kW a 220V 3F"},
                    {label: "Medidas", value: "73.5 x 73.5 x 199 cm"},
                    {label: "Canastilla", value: "50 x 50 cm"}
                ],
                tags: ["Lavalozas", "Industrial", "LCD", "Winterhalter"]
            },

            // ACCESORIOS PARA LAVALOZAS
            {
                id: "winter-coci-descal-a70ls-9l",
                name: "Descalcificador coci-descal-a70ls-9l",
                brand: "Winterhalter",
                category: "Accesorios",
                subcategory: "Accesorios para Lavalozas",
                price: 1856,
                description: "Ideal para lavalozas industriales. Permite retirar sales acumuladas, disolver cal y grasa para mantener el equipo en óptimas condiciones.",
                whatsappProduct: "WINTERHALTER COCI DESCAL A70LS 9L",
                image: "/img/catalogo/COCI-DESCAL-A70LS-9L.webp",
                manualPdf: "/docs/manuales/COCI-DESCAL-A70LS-9L.pdf",
                details: [
                    {label: "Uso", value: "Retirar sales y cal"},
                    {label: "Capacidad", value: "9 L"}
                ],
                tags: ["Accesorio", "Limpieza", "Descalcificador"]
            },
            {
                id: "winter-coci-deter-loza-f8400-9l",
                name: "Detergente coci-deter-loza-f8400-9l",
                brand: "Winterhalter",
                category: "Accesorios",
                subcategory: "Accesorios para Lavalozas",
                price: 1740,
                description: "Ideal para lavar: Vajilla, utensilios y plástico. Elimina residuos de proteína, manchas y almidones.",
                whatsappProduct: "WINTERHALTER COCI DETER LOZA F8400 9L",
                image: "/img/catalogo/COCI-DETER-LOZA-F8400-9L.webp",
                manualPdf: "/docs/manuales/COCI-DETER-LOZA-F8400-9L.pdf",
                details: [
                    {label: "Uso", value: "Lavado de loza y plásticos"},
                    {label: "Capacidad", value: "9 L"}
                ],
                tags: ["Accesorio", "Detergente", "Winterhalter"]
            },
            {
                id: "winter-coci-abri-loza-b100n-5l",
                name: "Abrillantador coci-abri-loza-b100n-5l",
                brand: "Winterhalter",
                category: "Accesorios",
                subcategory: "Accesorios para Lavalozas",
                price: 928,
                description: "Ideal para el secado: Vajillas, utensilios y cristalería. Aporta brillo a porcelana, aluminio y acero.",
                whatsappProduct: "WINTERHALTER COCI ABRI LOZA B100N 5L",
                image: "/img/catalogo/COCI-ABRI-LOZA-B100N-5L.webp",
                manualPdf: "/docs/manuales/COCI-ABRI-LOZA-B100N-5L.pdf",
                details: [
                    {label: "Uso", value: "Secado y brillo"},
                    {label: "Capacidad", value: "5 L"}
                ],
                tags: ["Accesorio", "Abrillantador", "Brillo"]
            }
        ],
        pagina20: [
            // MÁQUINAS DE CAFÉ
            {
                id: "cafe-delecta-2g",
                name: "Máquina de Café CAFE-DELECTA-2G",
                brand: "Delecta",
                category: "Cafetería-Bar",
                subcategory: "Máquinas de Café",
                price: 79373,
                description: "Cuenta con caldera de acero inoxidable de 10 litros, sistema de preinfusión electrónica programable y purga automática con alarma por falta de agua. Equipada con dos lanzas de vapor y un dispensador de agua caliente. Ofrece 4 dosis programables por grupo, además de control manual.",
                whatsappProduct: "CAFE DELECTA-2G",
                image: "/img/catalogo/CAFE-DELECTA-2G.webp",
                manualPdf: [
                    {label: "Manual de Usuario", url: "/docs/manuales/CAFE-DELECTA-2G.pdf-2.pdf"},
                    {label: "Ficha Técnica", url: "/docs/manuales/CAFE-DELECTA-2G-1.pdf"},
                    {label: "Características Técnicas", url: "/docs/manuales/CAFE-DELECTA-2G-3.pdf"}
                ],
                details: [
                    {label: "Capacidad de caldera", value: "10 L"},
                    {label: "Grupos", value: "2"},
                    {label: "Varillas de vapor", value: "2"},
                    {label: "Grifos de agua caliente", value: "1"},
                    {label: "Consumo energético", value: "3000 Watts"},
                    {label: "Voltaje", value: "220 V a 60 Hz monofásico"},
                    {label: "Medidas", value: "72 x 47 x 51 cm"}
                ],
                tags: ["Café", "Delecta", "Profesional"]
            },
            {
                id: "cafe-100-practical-e",
                name: "Máquina de Café CAFE-100-PRACTICAL-E",
                brand: "Express",
                category: "Cafetería-Bar",
                subcategory: "Máquinas de Café",
                price: 74182,
                description: "Equipada con tecnología IGTS para control individual de temperatura por grupo, sistema de limpieza automática y estructura en acero inoxidable anti-huellas. Ofrece hasta 6 dosis programables por grupo y botón de control manual. Incorpora 2 lanzas de vapor de alta presión y ciclo de lavado automático.",
                whatsappProduct: "CAFE 100 PRACTICAL E",
                image: "/img/catalogo/CAFE-100-PRACTICAL-E.webp",
                manualPdf: [
                    {label: "Manual de Usuario", url: "/docs/manuales/CAFE-100-PRACTICAL-E-2.pdf"},
                    {label: "Ficha Técnica", url: "/docs/manuales/CAFE-100-PRACTICAL-E-1.pdf"},
                    {label: "Características Técnicas", url: "/docs/manuales/CAFE-100-PRACTICAL-E-3.pdf"}
                ],
                details: [
                    {label: "Capacidad de caldera", value: "3 L"},
                    {label: "Grupos", value: "1"},
                    {label: "Grifos de agua caliente", value: "1"},
                    {label: "Consumo energético", value: "2000 Watts"},
                    {label: "Voltaje", value: "110 V a 60 Hz Monofásico"},
                    {label: "Dosis", value: "6 programables + botón manual"},
                    {label: "Dimensiones", value: "41 x 57 x 52 cm"}
                ],
                tags: ["Café", "Express", "1 Grupo"]
            },
            {
                id: "cafe-100-e-2gr",
                name: "Máquina de Café CAFE-100-E-2GR",
                brand: "Express",
                category: "Cafetería-Bar",
                subcategory: "Máquinas de Café",
                price: 82505,
                description: "Equipada con tecnología IGTS para control individual de temperatura por grupo, sistema de limpieza automática y estructura en acero inoxidable anti-huellas. Ofrece hasta 6 dosis programables por grupo y botón de control manual. Incorpora 2 lanzas de vapor de alta presión y ciclo de lavado automático.",
                whatsappProduct: "CAFE 100 E 2GR",
                image: "/img/catalogo/CAFE-100-E-2GR.webp",
                manualPdf: [
                    {label: "Manual de Usuario", url: "/docs/manuales/CAFE-100-E-2GR-2.pdf"},
                    {label: "Ficha Técnica", url: "/docs/manuales/CAFE-100-E-2GR-1.pdf"},
                    {label: "Características Técnicas", url: "/docs/manuales/CAFE-100-E-2GR-3.pdf"}
                ],
                details: [
                    {label: "Capacidad de caldera", value: "12 L"},
                    {label: "Grupos", value: "2"},
                    {label: "Grifos de agua caliente", value: "1"},
                    {label: "Consumo energético", value: "3500/4000 Watts"},
                    {label: "Voltaje", value: "220 V a 60 Hz monofásico"},
                    {label: "Dosis", value: "6 por grupo + botón manual"},
                    {label: "Medidas", value: "74 x 57 x 52 cm"}
                ],
                tags: ["Café", "Express", "2 Grupos"]
            },
            {
                id: "cafe-100-e-3g",
                name: "Máquina de Café CAFE-100-E-3G",
                brand: "Express",
                category: "Cafetería-Bar",
                subcategory: "Máquinas de Café",
                price: 133284,
                description: "Equipada con tecnología IGTS para control individual de temperatura por grupo, sistema de limpieza automática y estructura en acero inoxidable anti-huellas. Ofrece hasta 6 dosis programables por grupo y botón de control manual. Incorpora 2 lanzas de vapor de alta presión y ciclo de lavado automático.",
                whatsappProduct: "CAFE 100 E 3G",
                image: "/img/catalogo/CAFE-100-E-3G.webp",
                manualPdf: [
                    {label: "Manual de Usuario", url: "/docs/manuales/CAFE-100-E-3G-2.pdf"},
                    {label: "Ficha Técnica", url: "/docs/manuales/CAFE-100-E-3G-1.pdf"},
                    {label: "Características Técnicas", url: "/docs/manuales/CAFE-100-E-3G-3.pdf"}
                ],
                details: [
                    {label: "Capacidad de caldera", value: "19 L"},
                    {label: "Grupos", value: "3"},
                    {label: "Grifos de agua caliente", value: "1"},
                    {label: "Consumo energético", value: "5500 Watts"},
                    {label: "Voltaje", value: "220 V a 60 Hz monofásico"},
                    {label: "Dosis", value: "6 programables por grupo + control manual"},
                    {label: "Medidas", value: "98 x 57 x 52 cm"}
                ],
                tags: ["Café", "Express", "3 Grupos"]
            },
            {
                id: "cafe-20-20-plug-play",
                name: "Máquina de Café CAFE-20-20-PLUG-PLAY",
                brand: "Express",
                category: "Cafetería-Bar",
                subcategory: "Máquinas de Café",
                price: 54288,
                description: "Máquinas espresso de 1 grupo equipadas con doble caldera de acero inoxidable, pantalla LED táctil para control de temperatura y preinfusión, así como sistema PID de regulación térmica. Incorporan depósito interno de 5 L. Cuentan con 2 bombas de vibración, 2 ablandadores de agua integrados, lanza de vapor con control por palanca y bandeja de goteo inferior.",
                whatsappProduct: "CAFE 20/20 PLUG & PLAY",
                image: "/img/catalogo/CAFE-20-20-PLUG-PLAY.webp",
                manualPdf: [
                    {label: "Manual de Usuario", url: "/docs/manuales/CAFE-20-20-PLUG-PLAY-2.pdf"},
                    {label: "Ficha Técnica", url: "/docs/manuales/CAFE-20-20-PLUG-PLAY-1.pdf"},
                    {label: "Características Técnicas", url: "/docs/manuales/CAFE-20-20-PLUG-PLAY-3.pdf"}
                ],
                details: [
                    {label: "Capacidad de caldera", value: "5 L"},
                    {label: "Grupos", value: "1"},
                    {label: "Varillas de vapor", value: "1"},
                    {label: "Grifos de agua caliente", value: "1"},
                    {label: "Consumo energético", value: "2000 Watts"},
                    {label: "Voltaje", value: "110 V a 60 Hz Monofásico"},
                    {label: "Medidas", value: "38 x 47 x 55 cm"}
                ],
                tags: ["Café", "Express", "Táctil"]
            },
            {
                id: "cafe-20-20-space",
                name: "Máquina de Café CAFE-20-20-SPACE",
                brand: "Express",
                category: "Cafetería-Bar",
                subcategory: "Máquinas de Café",
                price: 82505,
                description: "Máquina espresso de 2 grupos equipada con doble caldera de acero inoxidable, pantalla LED táctil para control de temperatura y preinfusión, así como sistema PID de regulación térmica. Incorporan depósito interno de 5 L. Cuentan con 2 bombas de vibración, 2 ablandadores de agua integrados, lanza de vapor con control por palanca y bandeja de goteo inferior.",
                whatsappProduct: "CAFE 20/20 SPACE",
                image: "/img/catalogo/CAFE-20-20-SPACE.webp",
                manualPdf: [
                    {label: "Ficha Técnica", url: "/docs/manuales/CAFE-20-20-SPACE-1.pdf"},
                    {label: "Características Técnicas", url: "/docs/manuales/CAFE-20-20-SPACE-2.pdf"}
                ],
                details: [
                    {label: "Capacidad de caldera", value: "8 L"},
                    {label: "Grupos", value: "2"},
                    {label: "Varillas de vapor", value: "2"},
                    {label: "Grifos de agua caliente", value: "1"},
                    {label: "Consumo energético", value: "3000 Watts"},
                    {label: "Voltaje", value: "220 V a 60 Hz monofásico"},
                    {label: "Medidas", value: "57 x 55 x 47 cm"}
                ],
                tags: ["Café", "Express", "Space"]
            },
            {
                id: "cafe-20-20-classic-3-gr",
                name: "Máquina de Café CAFE-20-20-CLASSIC-3-GR",
                brand: "Express",
                category: "Cafetería-Bar",
                subcategory: "Máquinas de Café",
                price: 127803,
                description: "Máquina espresso equipada con doble caldera de acero inoxidable, pantalla LED táctil para control de temperatura y preinfusión, así como sistema PID de regulación térmica. Incorporan depósito interno de 5 L. Cuentan con 2 bombas de vibración, 2 ablandadores de agua integrados, lanza de vapor con control por palanca y bandeja de goteo inferior.",
                whatsappProduct: "CAFE 20/20 CLASSIC 3 GR",
                image: "/img/catalogo/CAFE-20-20-CLASSIC-3-GR.webp",
                manualPdf: [
                    {label: "Manual de Usuario", url: "/docs/manuales/CAFE-20-20-CLASSIC-3-GR-2.pdf"},
                    {label: "Ficha Técnica", url: "/docs/manuales/CAFE-20-20-CLASSIC-3-GR-1.pdf"},
                    {label: "Características Técnicas", url: "/docs/manuales/CAFE-20-20-CLASSIC-3-GR-3.pdf"}
                ],
                details: [
                    {label: "Capacidad de caldera", value: "19 L"},
                    {label: "Grupos", value: "3"},
                    {label: "Varillas de vapor", value: "2"},
                    {label: "Grifos de agua caliente", value: "1"},
                    {label: "Consumo energético", value: "5500 Watts"},
                    {label: "Voltaje", value: "220 V a 60 Hz monofásico"},
                    {label: "Medidas", value: "96 x 55 x 47 cm"}
                ],
                tags: ["Café", "Express", "Classic"]
            },

            {
                id: "cafe-sm-97-manuale",
                name: "Molino de Café CAFE-SM-97-MANUALE",
                brand: "Express",
                category: "Cafetería-Bar",
                subcategory: "Molinos",
                price: 17313,
                description: "Molinos de café de alto rendimiento equipados con tolva de 1.2 kg, dosificador de 250 g y muelas de 84 mm que operan a 900 rpm, con capacidad de hasta 13 kg/h. Ofrecen regulación de dosis de 5 a 9 g con contador integrado, ya sea manual, con parada automática o totalmente programables según modelo. Incorporan ajuste milimétrico, bajo nivel de ruido (69 dB) y funciones inteligentes en versiones avanzadas.",
                whatsappProduct: "CAFE SM-97-MANUALE",
                image: "/img/catalogo/CAFE-SM-97-MANUALE.webp",
                manualPdf: "/docs/manuales/CAFE-SM-97-MANUALE.pdf",
                details: [
                    {label: "Tipo", value: "Manual"},
                    {label: "Capacidad de tolva", value: "1.2 kg"},
                    {label: "Velocidad de muelas", value: "900 rpm"},
                    {label: "Capacidad de molienda", value: "13 kg/h"},
                    {label: "Regulación de molienda", value: "5 a 9 gr"},
                    {label: "Consumo energético", value: "515 Watts"},
                    {label: "Voltaje", value: "110 V a 60 Hz"},
                    {label: "Medidas", value: "20 x 36 x 61 cm"}
                ],
                tags: ["Molino", "Manual", "Express"]
            },
            {
                id: "cafe-sm-97-automatico",
                name: "Molino de Café CAFE-SM-97-AUTOMATICO",
                brand: "Express",
                category: "Cafetería-Bar",
                subcategory: "Molinos",
                price: 18067,
                description: "Molinos de café de alto rendimiento equipados con tolva de 1.2 kg, dosificador de 250 g y muelas de 84 mm que operan a 900 rpm, con capacidad de hasta 13 kg/h. Ofrecen regulación de dosis de 5 a 9 g con contador integrado, ya sea manual, con parada automática o totalmente programables según modelo. Incorporan ajuste milimétrico, bajo nivel de ruido (69 dB) y funciones inteligentes en versiones avanzadas.",
                whatsappProduct: "CAFE SM-97-AUTOMATICO",
                image: "/img/catalogo/CAFE-SM-97-AUTOMATICO.webp",
                manualPdf: "",
                details: [
                    {label: "Tipo", value: "Semi-Automático"},
                    {label: "Sistema", value: "Paro y arranque programado"},
                    {label: "Capacidad de tolva", value: "1.2 kg"},
                    {label: "Velocidad de muelas", value: "900 rpm"},
                    {label: "Capacidad de molienda", value: "13 kg/h"},
                    {label: "Regulación de molienda", value: "5 a 9 gr"},
                    {label: "Consumo energético", value: "515 Watts"},
                    {label: "Voltaje", value: "110 V a 60 Hz"},
                    {label: "Medidas", value: "20 x 36 x 61 cm"}
                ],
                tags: ["Molino", "Automático", "Express"]
            },
            {
                id: "cafe-sm-97-smart-instant",
                name: "Molino de Café CAFE-SM-97-SMART-INSTANT",
                brand: "Express",
                category: "Cafetería-Bar",
                subcategory: "Molinos",
                price: 24070,
                description: "Molinos de café de alto rendimiento equipados con tolva de 1.2 kg, dosificador de 250 g y muelas de 84 mm que operan a 900 rpm, con capacidad de hasta 13 kg/h. Ofrecen regulación de dosis de 5 a 9 g con contador integrado, ya sea manual, con parada automática o totalmente programables según modelo. Incorporan ajuste milimétrico, bajo nivel de ruido (69 dB) y funciones inteligentes en versiones avanzadas.",
                whatsappProduct: "CAFE SM-97-SMART-INSTANT",
                image: "/img/catalogo/CAFE-SM-97-SMART-INSTANT.webp",
                manualPdf: "/docs/manuales/CAFE-SM-97-SMART-INSTANT.pdf",
                details: [
                    {label: "Tipo", value: "Completamente Automatica"},
                    {label: "Dosificador", value: "250 g con parada automática"},
                    {label: "Sistema", value: "Inicio y paro automáticos según dosis"},
                    {label: "Capacidad de tolva", value: "1.2 kg"},
                    {label: "Velocidad de muelas", value: "900 rpm"},
                    {label: "Capacidad de molienda", value: "13 kg/h"},
                    {label: "Regulación de molienda", value: "5 a 9 gr"},
                    {label: "Consumo energético", value: "420 Watts"},
                    {label: "Voltaje", value: "110 V a 60 Hz"},
                    {label: "Medidas", value: "20 x 36 x 57 cm"}
                ],
                tags: ["Molino", "Smart", "Express"]
            }
        ],
    },
}

// 1. Extrae todos los productos de todo
const allProducts = Object.values(catalogos).flatMap(catalogo =>
    Object.values(catalogo).flat()
);

// 2. Exporta "products"
export const products = allProducts;